export default{
  poster:[
    {
      "number": "A01",
      "title": "Rethinking Nighttime Image Deraining via Learnable Color Space Transformation",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "大连工业大学",
      "author": "Qiyuan Guan, Xiang Chen, Guiyue Jin, Jiyu Jin, Shumin Fan, Tianyu Song, Jinshan Pan",
      "workshop": ""
    },
    {
      "number": "A02",
      "title": "SynthRGB-T: Language-Vision Guided Image Translation for Diversity Synthesis",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "长安大学",
      "author": "Jiangang Ding, Yiquan Du, Pengxiang Li, Lili Pei, Yuanlin Zhao, Wei Li",
      "workshop": ""
    },
    {
      "number": "A03",
      "title": "YOSE: You Only Select Essential Tokens for Efficient DiT-based Video Object Removal",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南开大学",
      "author": "Chenyang Wu, Lina Lei, Fan Li, Chunle Guo, Dehong Kong, Xinran Qin, Zhixin Wang, Mingming Cheng, Zhongyi Li",
      "workshop": ""
    },
    {
      "number": "A04",
      "title": "LongAnimation: Long Animation Generation with Dynamic Global-Local Memory",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "中国科学技术大学",
      "author": "Nan Chen, Mengqi Huang, Yihao Meng, Zhendong Mao",
      "workshop": ""
    },
    {
      "number": "A05",
      "title": "UniRain: Unified Image Deraining with RAG-based Dataset Distillation and Multi-objective Reweighted Optimization",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "大连工业大学",
      "author": "Qianfeng Yang, Qiyuan Guan, Xiang Chen, Jiyu Jin, Guiyue Jin, Jiangxin Dong",
      "workshop": ""
    },
    {
      "number": "A06",
      "title": "StreamDiffusionV2: A Streaming System for Dynamic and Interactive Video Generation",
      "qikan": "Machine Learning and Systems (MLSys) 2026",
      "unit": "德克萨斯大学奥斯汀分校",
      "author": "Tianrui Feng, Zhi Li, Shuo Yang, Haocheng Xi, Muyang Li, Xiuyu Li, Lvmin Zhang, Keting Yang, Kelly Peng, Song Han, Maneesh Agrawala, Kurt Keutzer, Akio Kodaira, Chenfeng Xu",
      "workshop": ""
    },
    {
      "number": "A07",
      "title": "FusionRegister: Every Infrared and Visible Image Fusion Deserves Registration",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "江南大学",
      "author": "Congcong Bian",
      "workshop": ""
    },
    {
      "number": "A08",
      "title": "Adaptive Dynamic Dehazing via Instruction-Driven and Task-Feedback Closed-Loop Optimization for Diverse Downstream Task Adaptation",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "昆明理工大学",
      "author": "Yafei Zhang, Shuaitian Song, Huafeng Li, Shujuan Wang, Yu Liu",
      "workshop": ""
    },
    {
      "number": "A09",
      "title": "EpiAgent: An Agent-Centric System for Ancient Inscription Restoration",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "东南大学",
      "author": "Shipeng Zhu, Ang Chen, Na Nie, Pengfei Fang, Minling Zhang, Hui Xue",
      "workshop": ""
    },
    {
      "number": "A10",
      "title": "Cycle-Consistent Tuning for Layered Image Decomposition",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "深圳大学",
      "author": "Zheng Gu, Min Lu, Zhida Sun, Dani Lischinski, Daniel Cohen-Or, Hui Huang",
      "workshop": ""
    },
    {
      "number": "A11",
      "title": "StyleShot: A SnapShot on Any Style",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "同济大学",
      "author": "Junyao Gao, Yanan Sun, Yanchen Liu, Yinhao Tang, Yanhong Ceng, Ding Qi, Kai Chen",
      "workshop": ""
    },
    {
      "number": "A12",
      "title": "CharaConsist: Fine-Grained Consistent Character Generation",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "北京交通大学",
      "author": "Mengyu Wang, Henghui Ding, Jianing Peng, Yao Zhao, Yunpeng Chen, Yunchao Wei",
      "workshop": ""
    },
    {
      "number": "A14",
      "title": "A Unified Solution to Video Fusion: From Multi-Frame Learning to Benchmarking",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "苏黎世联邦理工学院",
      "author": "Zixiang Zhao, Haowen Bai, Bingxin Ke, Yukun Cui, Lilun Deng, Yulun Zhang, Kai Zhang, Konrad Schindler",
      "workshop": ""
    },
    {
      "number": "A15",
      "title": "SMLNet: A SPD Manifold Learning Network for Infrared and Visible Image Fusion",
      "qikan": "International Journal of Computer Vision (IJCV) 2025",
      "unit": "江南大学",
      "author": "Huan Kang, Hui Li, Tianyang Xu, Xiao-Jun Wu, Rui Wang, Chunyang Cheng, Josef Kittler",
      "workshop": ""
    },
    {
      "number": "A16",
      "title": "Learning Continuous Wasserstein Barycenter Space for Generalized All-in-One Image Restoration",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "西安交通大学",
      "author": "Xiaole Tang, Xiaoyi He, Jiayi Xu, Xiang Gu, Jian Sun",
      "workshop": ""
    },
    {
      "number": "A17",
      "title": "Taming Generative Diffusion Model for Task-Oriented Infrared Imaging",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "大连理工大学",
      "author": "Tengyu Ma, Zhilong Dai, Yubo Diao, Guanming An, Long Ma, Jinyuan Liu, Risheng Liu",
      "workshop": ""
    },
    {
      "number": "A18",
      "title": "High-Quality and Efficient Turbulence Mitigation with Events",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "华中科技大学",
      "author": "Xiaoran Zhang, Jian Ding, Yuxing Duan, Haoyue Liu, Gang Chen, Yi Chang, Luxin Yan",
      "workshop": ""
    },
    {
      "number": "A19",
      "title": "OmniVTON: Training-free Universal Virtual Try-On",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "南京理工大学",
      "author": "Zhaotong Yang, Yuhui Li, Shengfeng He, Xinzhe Li, Yangyang Xu, Junyu Dong, Yong Dou",
      "workshop": ""
    },
    {
      "number": "A20",
      "title": "Plenodium: Underwater 3D Scene Reconstruction with Plenoptic Medium Representation",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "南京理工大学",
      "author": "Changguang Wu, Chengjian Li, Jiangxin Dong, Jinhui Tang",
      "workshop": ""
    },
    {
      "number": "A21",
      "title": "GFRRN: Explore the Gaps in Single Image Reflection Removal",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "浙江大学",
      "author": "Yu Chen, Zewei He, Xingyu Liu, Zixuan Chen, Zheming Lu",
      "workshop": ""
    },
    {
      "number": "A22",
      "title": "FlashWorld: High-quality 3D Scene Generation within Seconds",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "厦门大学",
      "author": "Xinyang Li, Tengfei Wang, Zixiao Gu, Shengchuan Zhang, Chunchao Guo, Liujuan Cao",
      "workshop": ""
    },
    {
      "number": "A23",
      "title": "Luminance-Aware Statistical Quantization: Unsupervised Hierarchical Learning for Illumination Enhancement",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "国防科技大学",
      "author": "Derong Kong, Zhixiong Yang, Shengxi Li, Shuaifeng Zhi, Li Liu, Zhen Liu, Jingyuan Xia",
      "workshop": ""
    },
    {
      "number": "A25",
      "title": "Scan Clusters， Not Pixels: A Cluster-Centric Paradigm for Efficient Ultra-high-definition Image Restoration",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "国防科技大学",
      "author": "Chen Wu, Ling Wang, Zhuoran Zheng, Yuning Cui, Zhixiong Yang, Xiangyu Chen, Yue Zhang, Weidong Jiang, Jingyuan Xia",
      "workshop": ""
    },
    {
      "number": "A26",
      "title": "BiProLoRA: Bilevel Prompt LoRA for Real Scene Recovery",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "大连理工大学",
      "author": "Nan An, Long Ma, Tengyu Ma, Zhu Liu, Yingchi Liu, Risheng Liu",
      "workshop": ""
    },
    {
      "number": "A27",
      "title": "Learning Physics-Informed Noise Models from Dark Frames for Low-Light Raw Image Denoising",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "北京理工大学",
      "author": "Hansen Feng, Lizhi Wang, Yiqi Huang, Yuzhi Wang, Lin Zhu, Hua Huang",
      "workshop": ""
    },
    {
      "number": "A29",
      "title": "Mixture of Style Experts for Diverse Image Stylization",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南开大学",
      "author": "Shihao Zhu, Ziheng Ouyang, Yijia Kang, Qilong Wang, Mi Zhou, Bo Li, Ming-Ming Cheng, Qibin Hou",
      "workshop": ""
    },
    {
      "number": "A30",
      "title": "Context as Memory: Scene-Consistent Interactive Long Video Generation with Memory Retrieval",
      "qikan": "ACM SIGGRAPH Asia (SIGGRAPH Asia) 2025",
      "unit": "香港大学",
      "author": "Jiwen Yu, Jianhong Bai, Yiran Qin, Quande Liu, Xintao Wang, Pengfei Wan, Xihui Liu",
      "workshop": ""
    },
    {
      "number": "A32",
      "title": "Incorporating Uncertainty Guided and Topk Codebook Matching for Real World Blind Image Super Resolution",
      "qikan": "IEEE Transactions on Image Processing (TIP) 2026",
      "unit": "汕头大学",
      "author": "Weilei Wen, Tianyi Zhang, Qianqian Zhao, Zhaohui Zheng, Chunle Guo, Xiuli Shao, Zhongyi Li",
      "workshop": ""
    },
    {
      "number": "A33",
      "title": "Markovian Scale Prediction: A New Era of Visual Autoregressive Generation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "同济大学",
      "author": "Yu Zhang, Jingyi Liu, Yiwei Shi, Qi Zhang, Duoqian Miao, Changwei Wang, Longbing Cao",
      "workshop": ""
    },
    {
      "number": "A34",
      "title": "PG-VTON: Single-Pass Training-Free Virtual Try-On via Patch-Guided Reference Alignment",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "北京大学",
      "author": "Guohao Zhao, Yuxin Peng",
      "workshop": ""
    },
    {
      "number": "A35",
      "title": "CAST-LUT: Tokenizer-Guided HSV Look-Up Tables for Purple Flare Removal",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "山东大学",
      "author": "Pu Wang, Shuning Sun, Jialang Lu, Chen Wu, Zhihua Zhang, Youshan Zhang, Chenggang Dan, Dianjie Lu, Guijuan Zhang, Zhuoran Zheng",
      "workshop": ""
    },
    {
      "number": "A36",
      "title": "SpatioTemporal Difference Network for Video Depth Super-Resolution",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "南京理工大学",
      "author": "Zhengxue Wang, Yuan Wu, Xiang Li, Zhiqiang Yan, Jian Yang",
      "workshop": ""
    },
    {
      "number": "A37",
      "title": "EvTexture++: Event-Driven Texture Enhancement for Video Super-Resolution",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "中国科学技术大学",
      "author": "Dachun Kai, Jiayao Lu, Yueyi Zhang, Xiaoyan Sun",
      "workshop": ""
    },
    {
      "number": "A39",
      "title": "Efficient Rectified Flow for Image Fusion",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "香港城市大学",
      "author": "Zirui Wang, Jiayi Zhang, Tianwei Guan, Yuhan Zhou, Xingyuan Li, Minjing Dong, Jinyuan Liu",
      "workshop": ""
    },
    {
      "number": "A40",
      "title": "Conditional Prompt Learning via Degradation Perception for Underwater Image Enhancement",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "大连海事大学",
      "author": "Mingze Yao, Zhiying Jiang, Xianping Fu, Huibing Wang",
      "workshop": ""
    },
    {
      "number": "A41",
      "title": "UniFusion: A Unified Image Fusion Framework with Robust Representation and Source-Aware Preservation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "浙江大学",
      "author": "Xingyuan Li, Songcheng Du, Yang Zou, Haoyuan Xu, Zhiying Jiang, Jinyuan Liu",
      "workshop": ""
    },
    {
      "number": "A42",
      "title": "STAR: A Benchmark for Astronomical Star Fields Super-Resolution",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "合肥工业大学",
      "author": "Guocheng Wu, Guohang Zhuang, Jinyang Huang, Xiang Zhang, Wanli Ouyang, Yan Lu",
      "workshop": ""
    },
    {
      "number": "A43",
      "title": "Blind Noisy Image Deblurring Using Residual Guidance Strategy",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "东北师范大学",
      "author": "Heyan Liu, Jianing Sun, Jun Liu, Xile Zhao, Tingting Wu, Tieyong Ceng",
      "workshop": ""
    },
    {
      "number": "A44",
      "title": "Depth-Synergized Mamba Meets Memory Experts for All-Day Image Reflection Separation",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "华中科技大学",
      "author": "Siyan Fang, Long Peng, Yuntao Wang, Ruonan Wei, Yuehuan Wang",
      "workshop": ""
    },
    {
      "number": "A45",
      "title": "LucidFlux: Caption-Free Photo-Realistic Image Restoration via a Large-Scale Diffusion Transformer",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "香港科技大学（广州）",
      "author": "Song Fei, Tian Ye, Lujia Wang, Lei Zhu",
      "workshop": ""
    },
    {
      "number": "A46",
      "title": "UltraFlux: Data-Model Co-Design for High-quality Native 4K Text-to-Image Generation across Diverse Aspect Ratios",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "香港科技大学（广州）",
      "author": "Tian Ye, Song Fei, Lei Zhu",
      "workshop": ""
    },
    {
      "number": "A47",
      "title": "Consistent and Controllable Image Animation with Linear Motion Diffusion Transformers",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "上海人工智能实验室",
      "author": "Xin Ma, Yaohui Wang, Gengyun Jia, Xinyuan Chen, Tianjin Huang, Cunjian Chen",
      "workshop": ""
    },
    {
      "number": "A48",
      "title": "NoiseController: Towards Consistent Multi-view Video Generation via Noise Decomposition and Collaboration",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "天津大学",
      "author": "Haotian Dong, Xin Wang, Di Lin, Yipeng Wu, Qin Chen, Ruonan Liu, Kairui Yang, Ping Li, Qing Guo",
      "workshop": ""
    },
    {
      "number": "A49",
      "title": "Highlight What You Want: Weakly-Supervised Instance-Level Controllable Infrared-Visible Image Fusion",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "大连民族大学",
      "author": "Zeyu Wang, Jizheng Zhang, Haiyu Song, Mingyu Ge, Jiayu Wang, Haoran Duan",
      "workshop": ""
    },
    {
      "number": "A50",
      "title": "Narrative Weaver: Towards Controllable Long-Range Visual Consistency with Multi-Modal Conditioning",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "北京大学",
      "author": "Zhengjian Yao, Yongzhi Li, Xinyuan Gao, Quan Chen, Peng Jiang, Yanye Lu",
      "workshop": ""
    },
    {
      "number": "A51",
      "title": "Sega: A stepwise evolution paradigm for content-aware layout generation with design prior",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "南京大学",
      "author": "Haoran Wang, Bo Zhao, Jinghui Wang, Hanzhang Wang, Huan Yang, Wei Ji, Xinyan Xiao",
      "workshop": ""
    },
    {
      "number": "A52",
      "title": "FoundIR-v2: Optimizing Pre-Training Data Mixtures for Image Restoration Foundation Model",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京理工大学",
      "author": "Xiang Chen, Jinshan Pan, Jiangxin Dong, Jian Yang, Jinhui Tang",
      "workshop": ""
    },
    {
      "number": "A53",
      "title": "A Color Information Driven Collaborative Training of Dual Task Parallel Network for Visible and Thermal Infrared Image Fusion and Saliency Object Detection",
      "qikan": "International Journal of Computer Vision (IJCV) 2026",
      "unit": "江南大学",
      "author": "Zeyang Zhang, Hui Li, Tianyang Xu, Xiaojun Wu, Muhammad Awais, Josef Kittler",
      "workshop": ""
    },
    {
      "number": "A54",
      "title": "PortraitSR: Artist-Inspired Prior Learning for Progressive Face Super-Resolution",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "重庆邮电大学",
      "author": "Miaoqing Wang, Jiaxu Leng, Shuang Li, Changjiang Kuang, Long Sun",
      "workshop": ""
    },
    {
      "number": "A56",
      "title": "Statistical Characteristic-Guided Denoising for Rapid High-Resolution Transmission Electron Microscopy Imaging",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "北京理工大学",
      "author": "Hesong Li, Ziqi Wu, Ruiwen Shao, Ying Fu",
      "workshop": ""
    },
    {
      "number": "A57",
      "title": "Adaptive Discretization for Consistency Models",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "华中科技大学 电子信息与通信学院",
      "author": "Jiayu Bai, Zhanbo Feng, Zhijie Deng, Tianqi Hou, Caiming Qiu, Zenan Ling",
      "workshop": ""
    },
    {
      "number": "A59",
      "title": "Bilevel Layer-Positioning LoRA for Real Image Dehazing",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中山大学",
      "author": "Yan Zhang, Long Ma, Yuxin Feng, Zhe Huang, Fan Zhou, Zhuo Su",
      "workshop": ""
    },
    {
      "number": "A60",
      "title": "STCDiT: Spatio-Temporally Consistent Diffusion Transformer for High-Quality Video Super-Resolution",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京理工大学",
      "author": "Junyang Chen, Jiangxin Dong, Long Sun, Yixin Yang, Jinshan Pan",
      "workshop": ""
    },
    {
      "number": "A61",
      "title": "Toward Real-world Infrared Image Super-Resolution: A Unified Autoregressive Framework and Benchmark Dataset",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "西北工业大学",
      "author": "Yang Zou, Jun Ma, Zhidong Jiao, Xingyuan Li, Zhiying Jiang, Jinyuan Liu",
      "workshop": ""
    },
    {
      "number": "A62",
      "title": "Geometry Forcing: Marrying Video Diffusion and 3D Representation for Consistent World Modeling",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "MSRA",
      "author": "Haoyu Wu, Diankun Wu, Tianyu He, Yang Ye, Junliang Guo, Jiang Bian",
      "workshop": ""
    },
    {
      "number": "A63",
      "title": "Degradation-Robust Fusion: An Efficient Degradation-Aware Diffusion Framework for Multimodal Image Fusion in Arbitrary Degradation Scenarios",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "合肥工业大学",
      "author": "Yu Shi, Yu Liu, Zhongcheng Wu, Juan Cheng, Huafeng Li, Xun Chen",
      "workshop": ""
    },
    {
      "number": "A64",
      "title": "Gaussian Splatting-based Low-Rank Tensor Representation for Multi-Dimensional Image Recovery",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "电子科技大学",
      "author": "Yiming Zeng, Xile Zhao, Weihao Wu, Tengyu Ji, Chao Wang",
      "workshop": ""
    },
    {
      "number": "A65",
      "title": "Real-Time Scene-Adaptive Tone Mapping for High-Dynamic Range Object Detection",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2026",
      "unit": "香港中文大学（深圳）",
      "author": "Gongzhe Li, Linwei Qiu, Peibei Cao, Fengying Xie, Xiangyang Ji, Qilin Sun",
      "workshop": ""
    },
    {
      "number": "B01",
      "title": "SafeGRPO: Self-Rewarded Multimodal Safety Alignment via Rule-Governed Policy Optimization",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "武汉大学",
      "author": "Xuankun Rong, Wenke Huang, Tingfeng Wang, Daiguo Zhou, Bo Du, Mang Ye",
      "workshop": ""
    },
    {
      "number": "B03",
      "title": "Advancing Textual Prompt Learning with Anchored Attributes.",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "南开大学",
      "author": "Zheng Li, Yibing Song, Mingming Cheng, Xiang Li, Jian Yang",
      "workshop": ""
    },
    {
      "number": "B04",
      "title": "CtrlFuse: Mask-Prompt Guided Controllable Infrared and Visible Image Fusion",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "东南大学",
      "author": "Yiming Sun, Yuan Ruan, Qinghua Hu, Pengfei Zhu",
      "workshop": ""
    },
    {
      "number": "B05",
      "title": "ReaSon: Reinforced Causal Search with Information Bottleneck for Video Understanding",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "南京信息工程大学",
      "author": "Yuan Zhou, Litao Hua, Shilong Jin, Wentao Huang, Haoran Duan",
      "workshop": ""
    },
    {
      "number": "B07",
      "title": "Learning with Dual-level Noisy Correspondence for Multi-modal Entity Alignment",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "四川大学",
      "author": "Haobin Li, Yijie Lin, Peng Hu, Mouxing Yang, Xi Peng",
      "workshop": ""
    },
    {
      "number": "B08",
      "title": "DrivePI: Spatial-aware 4D MLLM for Unified Autonomous Driving Understanding， Perception， Prediction and Planning",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "香港大学",
      "author": "Zhe Liu, Runhui Huang, Rui Yang, Siming Yan, Zining Wang, Lu Hou, Di Lin, Xiang Bai, Hengshuang Zhao",
      "workshop": ""
    },
    {
      "number": "B09",
      "title": "KeepLoRA: Continual Learning with Residual Gradient Adaptation",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "东南大学",
      "author": "Maolin Luo, Zihao Zhou, Yilin Zhang, Yuanyu Wan, Minling Zhang, Tong Wei",
      "workshop": ""
    },
    {
      "number": "B10",
      "title": "Echoes of ownership: Adversarial-guided dual injection for copyright protection in MLLMs",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "兰州大学",
      "author": "Chengwei Xia, Fan Ma, Ruijie Quan, Kun Zhan, Yi Yang",
      "workshop": ""
    },
    {
      "number": "B11",
      "title": "VL-SAE: Interpreting and Enhancing Vision-Language Alignment with a Unified Concept Set",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "中国科学院计算技术研究所",
      "author": "Shufan Shen, Juanshu Sun, Qingming Huang, Shuhui Wang",
      "workshop": ""
    },
    {
      "number": "B12",
      "title": "ORION: A Holistic End-to-End Autonomous Driving Framework by Vision-Language Instructed Action Generation",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "华中科技大学",
      "author": "Haoyu Fu, Diankun Zhang, Zongchuang Zhao, Jianfeng Cui, Dingkang Liang, Chong Zhang, Dingyuan Zhang, Hongwei Xie, Bing Wang, Xiang Bai",
      "workshop": ""
    },
    {
      "number": "B14",
      "title": "Progressive Distribution Bridging: Unsupervised Adaptation for Large-scale Pre-trained Models via Adaptive Auxiliary Data",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "中国科学技术大学",
      "author": "Weinan He, Yixin Zhang, Zilei Wang",
      "workshop": ""
    },
    {
      "number": "B15",
      "title": "LLaVA-4D: Embedding SpatioTemporal Prompt into LMMs for 4D Scene Understanding",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "新加坡国立大学",
      "author": "Hanyu Zhou, Gim Hee Lee",
      "workshop": ""
    },
    {
      "number": "B17",
      "title": "EMO-R3: Reflective Reinforcement Learning for Emotional Reasoning in Multimodal Large Language Models",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "武汉大学",
      "author": "Yiyang Fang, Wenke Huang, Pei Fu, Yihao Yang, Kehua Su, Zhenbo Luo, Jian Luan, Mang Ye",
      "workshop": ""
    },
    {
      "number": "B18",
      "title": "Fine-R1: Make Multi-modal LLMs Excel in Fine-Grained Visual Recognition by Chain-of-Thought Reasoning",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "北京大学",
      "author": "Hulingxiao He, Zijun Geng, Yuxin Peng",
      "workshop": ""
    },
    {
      "number": "B19",
      "title": "RSVG-ZeroOV: Exploring a Training-Free Framework for Zero-Shot Open-Vocabulary Visual Grounding in Remote Sensing Images",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "西安电子科技大学",
      "author": "Ke Li, Di Wang, Ting Wang, Fuyu Dong, Yiming Zhang, Luyao Zhang, Xiangyu Wang, Quan Wang",
      "workshop": ""
    },
    {
      "number": "B20",
      "title": "Revolutionizing Training-Free NAS: Towards Efficient Automatic Proxy Discovery via Large Language Models",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "东北大学",
      "author": "Haidong Kang, Lihong Lin, Hanling Wang",
      "workshop": ""
    },
    {
      "number": "B21",
      "title": "conditional representation learning for customized tasks",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "四川大学",
      "author": "Honglin Liu, Chao Sun, Peng Hu, Yunfan Li, Xi Peng",
      "workshop": ""
    },
    {
      "number": "B22",
      "title": "Mixing Importance with Diversity: Joint Optimization for KV Cache Compression in Large Vision-Language Models",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "四川大学",
      "author": "Xuyang Liu, Xiyan Gui, Yuchao Zhang, Linfeng Zhang",
      "workshop": ""
    },
    {
      "number": "B23",
      "title": "iLLaVA: An Image is Worth Fewer Than 1/3 Input Tokens in Large Multimodal Models",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "南洋理工大学",
      "author": "Lianyu Hu, Liqing Gao, Fanhua Shang, Liang Wan, Wei Feng",
      "workshop": ""
    },
    {
      "number": "B24",
      "title": "Task-Specific Directions: Definition， Exploration， and Utilization in Parameter Efficient Fine-Tuning",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "上海交通大学",
      "author": "Chongjie Si, Zhiyi Shi, Shifan Zhang, Xiaokang Yang, Hanspeter Pfister, Wei Shen",
      "workshop": ""
    },
    {
      "number": "B25",
      "title": "Scaling Diffusion Transformers Efficiently via μP",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "中国人民大学",
      "author": "Chenyu Zheng, Xinyu Zhang, Rongzhen Wang, Wei Huang, Zhi Tian, Weilin Huang, Jun Zhu, Chongxuan Li",
      "workshop": ""
    },
    {
      "number": "B26",
      "title": "RemoteReasoner: Towards Unifying Geospatial Reasoning Workflow",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "河海大学",
      "author": "Liang Yao, Fan Liu, Hongbo Lu, Chuanyi Zhang, Rui Min, Shengxiang Xu, Shimin Di, Pai Peng",
      "workshop": ""
    },
    {
      "number": "B27",
      "title": "AV-Edit: Multimodal Generative Sound Effect Editing via Audio-Visual Semantic Joint Control",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "小米科技（武汉）有限公司",
      "author": "Xinyue Guo, Xiaoran Yang, Lipan Zhang, Jianxuan Yang, Zhao Wang, Jian Luan",
      "workshop": ""
    },
    {
      "number": "B28",
      "title": "Pixel2Phys: Distilling Governing Laws from Visual Dynamics",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "上海人工智能实验室",
      "author": "Ruikun Li, Jun Yao, Yingfan Hua, Shixiang Tang, Biqing Qi, Bin Liu, Wanli Ouyang, Yan Lu",
      "workshop": ""
    },
    {
      "number": "B29",
      "title": "Semantic-Augmented Image Clustering via Adaptive Multi-Modal Collaboration",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "南京大学",
      "author": "Xiaohan Zhang, Chao Zhang, Deng Xu, Hong YU, Chunlin Chen, Huaxiong Li",
      "workshop": ""
    },
    {
      "number": "B30",
      "title": "OralGPT-Omni: A Versatile Dental Multimodal Large Language Model",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "香港大学",
      "author": "Jing Hao, Yuci Liang, Lizhuo Lin, Yuxuan Fan, Wenkai Zhou, Kaixin Guo, Zanting Ye, Yanpeng Sun, Xinyu Zhang, Yanqi Yang, Qiankun Li, Hao Tang, James Kit-Hon Tsoi, Linlin Shen, Guofeng Hong",
      "workshop": ""
    },
    {
      "number": "B31",
      "title": "Depth-Supervised Fusion Network for Seamless-Free Image Stitching",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "大连海事大学",
      "author": "Zhiying Jiang, Ruhao Yan, Cengxi Zhang, Bowei Zhang, Jinyuan Liu",
      "workshop": ""
    },
    {
      "number": "B32",
      "title": "Robust Pedestrian Detection with Uncertain Modality",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "武汉科技大学",
      "author": "Qian Bie, Xiao Wang, Bin Yang, Zhixi Yu, Jun Chen, Xin Xu",
      "workshop": ""
    },
    {
      "number": "B33",
      "title": "VLM-R3: Region Recognition， Reasoning， and Refinement for Enhanced Multimodal Chain-of-Thought",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "北京大学",
      "author": "Chaoya Jiang, Yongrui Heng, Wei Ye, Han Yang, Haiyang Xu, Ming Yan, Ji Zhang, Fei Huang, Shikun Zhang",
      "workshop": ""
    },
    {
      "number": "B34",
      "title": "CogAgent: Self-Evolving Cognitive Agents for Multi-Source Fraud Detection in Heterogeneous Financial Networks",
      "qikan": "International World Wide Web Conference (WWW) 2026",
      "unit": "池州学院",
      "author": "Qianyu Wang, Weiyou Tian, Rong Wang, Weide Cai, Tianyu Shi, Zhuang Liu, Tianze Xia",
      "workshop": ""
    },
    {
      "number": "B35",
      "title": "Any-SSR: How Recursive Least Squares Works in Continual Learning of Large Language Models",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "华南理工大学",
      "author": "Kai Tong, Kang Pan, Xiao Zhang, Erli Meng, Run He, Yawen Cui, Nuoyan Guo, Huiping Zhuang",
      "workshop": ""
    },
    {
      "number": "B36",
      "title": "Filter， Correlate， Compress: Training-Free Token Reduction for MLLM Acceleration",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "阿里巴巴达摩院",
      "author": "Yuhang Han, Xuyang Liu, Zihan Zhang, Pengxiang Ding, Junjie Chen, Honggang Chen, Donglin Wang, Qingsen Yan",
      "workshop": ""
    },
    {
      "number": "B37",
      "title": "InfMasking: Unleashing Synergistic Information by Contrastive Multimodal Interactions",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "西南财经大学",
      "author": "Liangjian Wen, Qun Dai, Jianzhuang Liu, Jiangtao Zheng, Yong Dai, Dongkai Wang, Zhao Kang, Jun Wang, Zenglin Xu, Jiang Duan",
      "workshop": ""
    },
    {
      "number": "B38",
      "title": "Knowledge-guided adaptation of pathology foundation models effectively improves cross-domain generalization and demographic fairness",
      "qikan": "Nature Communications 2025",
      "unit": "香港大学",
      "author": "Yanyan Huang, Weiqin Zhao, Zhengyu Zhang, Yihang Chen, Yu Fu, Feng Wu, Yuming Jiang, Li Liang, Shujun Wang, Lequan Yu",
      "workshop": ""
    },
    {
      "number": "B39",
      "title": "Detecting Misbehaviors of Large Vision-Language Models by Evidential Uncertainty Quantification",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "北京交通大学",
      "author": "Tao Huang, Rui Wang, Xiaofei Liu, Yi Qin, Li Duan, Liping Jing",
      "workshop": ""
    },
    {
      "number": "B40",
      "title": "FlexLoRA: Entropy-Guided Flexible Low-Rank Adaptation",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "东南大学吴健雄学院",
      "author": "Muqing Liu, Chongjie Si, Yuheng Jia",
      "workshop": ""
    },
    {
      "number": "B41",
      "title": "Thinking with Camera: A Unified Multimodal Model for Camera-Centric Understanding and Generation",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "新加坡南洋理工大学",
      "author": "Kang Liao, Size Wu, Zhonghua Wu, Linyi Jin, Chao Wang, Yikai Wang, Fei Wang, Wei Li, Chen Change Loy",
      "workshop": ""
    },
    {
      "number": "B42",
      "title": "GeoAgent: Learning to Geolocate Everywhere with Reinforced Geographic Characteristics",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南开大学",
      "author": "Modi Jin, Yiming Zhang, Boyuan Sun, Dingwen Zhang, Mingming Cheng, Qibin Hou",
      "workshop": ""
    },
    {
      "number": "B44",
      "title": "DisasterM3: A Remote Sensing Vision-Language Dataset for Disaster Damage Assessment and Response",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "东京大学",
      "author": "Junjue Wang, Weihao Xuan, Heli Qi, Zhihao Liu, Kunyi Liu, Yuhan Wu, Hongruixuan Chen, Jian Song, Junshi Xia, Zhuo Zheng, Naoto Yokoya",
      "workshop": ""
    },
    {
      "number": "B45",
      "title": "Vision-centric Token Compression in Large Language Model",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "南京理工大学",
      "author": "Ling Xing, Jinpeng Wang, Rui Yan, Xiangbo Shu, Jinhui Tang",
      "workshop": ""
    },
    {
      "number": "B46",
      "title": "Eagle 2.5: Boosting Long-Context Post-Training for Frontier Vision-Language Models",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "南京大学",
      "author": "Guo Chen, Zhiqi Li, Shihao Wang, Jindong Jiang, Yicheng Liu, Lidong Lu, De-An Huang, Wonmin Byeon, Matthieu Le, Max Ehrlich, Tong Lu, Limin Wang, Bryan Catanzaro, Jan Kautz, Andrew Tao, Zhiding Yu, Guilin Liu",
      "workshop": ""
    },
    {
      "number": "B47",
      "title": "Landscape of Thoughts: Visualizing the Reasoning Process of Large Language Models",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "香港浸会大学",
      "author": "Zhanke Zhou, Zhaocheng Zhu, Xuan Li, Mikhail Galkin, Xiao Feng, Sanmi Koyejo, Jian Tang, Bo Han",
      "workshop": ""
    },
    {
      "number": "B48",
      "title": "Attention to the burstiness in visual prompt tuning",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "之江实验室",
      "author": "Yuzhu Wang, Manni Duan, Shu Kong",
      "workshop": ""
    },
    {
      "number": "B49",
      "title": "AV-Reasoner: Improving and Benchmarking Clue-Grounded Audio-Visual Counting for MLLMs",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京大学",
      "author": "Lidong Lu, Guo Chen, Wei Zhu, Zhiqi Li, Yicheng Liu, Tong Lu",
      "workshop": ""
    },
    {
      "number": "B50",
      "title": "HAMMER: Harnessing MLLM via Cross-Modal Integration for Intention-Driven 3D Affordance Grounding",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "香港理工大学",
      "author": "Lei Yao, Yong Chen, Yuejiao Su, Yi Wang, Moyun Liu, Lap-Pui Chau",
      "workshop": ""
    },
    {
      "number": "B51",
      "title": "COSMO: Combination of Selective Memorization for  Low-cost Vision-and-Language Navigation",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "同济大学",
      "author": "Siqi Zhang, Yanyuan Qiao, Qunbo Wang, Zike Yan, Qi Wu, Zhihua Wei, Jing Liu",
      "workshop": ""
    },
    {
      "number": "B52",
      "title": "Open-World 3D Scene Graph Generation for Retrieval-Augmented Reasoning",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "辽宁工业大学",
      "author": "Fei Yu, Quan Deng, Shengeng Tang, Yuehua Li, Lechao Cheng",
      "workshop": ""
    },
    {
      "number": "B53",
      "title": "VideoWorld 2: Learning Transferable Knowledge from Real-world Videos",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "北京交通大学",
      "author": "Zhongwei Ren, Yunchao Wei, Xiao Yu, Guixun Luo, Yao Zhao, Bingyi Kang, Jiashi Feng, Xiaojie Jin",
      "workshop": ""
    },
    {
      "number": "B54",
      "title": "MARC: Memory-Augmented RL Token Compression for Efficient Video Understanding",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "Memories.ai",
      "author": "Peiran Wu, Zhuorui Yu, Yunze Liu, Zhihao Wu, Enmin Zhou, Junxiao Shen",
      "workshop": ""
    },
    {
      "number": "B55",
      "title": "Earth-Agent: Unlocking the Full Landscape of Earth Observation with Agents",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "上海人工智能实验室",
      "author": "Peilin Feng, Zhutao Lv, Junyanwangxiaolei Ye, Xinjie Huo, Jinhua Yu, Wanghan Xu, Wenlong Zhang, Lei Bai, Conghui He, Weijia Li",
      "workshop": ""
    },
    {
      "number": "B57",
      "title": "Multimodal Negative Learning",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "天津大学人工智能学院",
      "author": "Baoquan Gong, Xiyuan Gao, Pengfei Zhu, Qinghua Hu, Bing Cao",
      "workshop": ""
    },
    {
      "number": "C01",
      "title": "Improving Batch Normalization with Test-Time Adaptation for Robust Object Detection in Self-Driving",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "北京邮电大学",
      "author": "Dacheng Liao, Mengshi Qi, Liang Liu, Huadong Ma",
      "workshop": ""
    },
    {
      "number": "C03",
      "title": "WOW-Seg: A Word-free Open World Segmentation Model",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "南开大学",
      "author": "Danyang Li, Tianhao Wu, Bin Lin, Zhenyuan Chen, Yang Zhang, Yuxuan Li, Mingming Cheng, Xiang Li",
      "workshop": ""
    },
    {
      "number": "C04",
      "title": "Revisiting End-to-End Learning with Slide-level Supervision in Computational Pathology",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "南开大学",
      "author": "Wenhao Tang, Rong Qin, Hang Fang, Fengtao Zhou, Hao Chen, Xiang Li, Mingming Cheng",
      "workshop": ""
    },
    {
      "number": "C06",
      "title": "SM3Det: A Unified Model for Multi-Modal Remote Sensing Object Detection",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "南开大学",
      "author": "Yuxuan Li, Xiang Li, Yunheng Li, Yicheng Zhang, Yimian Dai, Qibin Hou, Mingming Cheng, Jian Yang",
      "workshop": ""
    },
    {
      "number": "C07",
      "title": "Interaction-aware Representation Modeling With Co-Occurrence Consistency for Egocentric Hand-Object Parsing",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "香港理工大学",
      "author": "Yuejiao Su, Yi Wang, Lei Yao, Yawen Cui, Lap-Pui Chau",
      "workshop": ""
    },
    {
      "number": "C08",
      "title": "OmniHD-Scenes: A Next-Generation Multimodal Dataset for Autonomous Driving",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "同济大学",
      "author": "Lianqing Zheng, Long Yang, Qunshu Lin, Wenjin Ai, Minghao Liu, Shouyi Lu, Jianan Liu, Hongze Ren, Jingyue Mo, Xiaokai Bai, Jie Bai, Zhixiong Ma, Xichan Zhu",
      "workshop": ""
    },
    {
      "number": "C09",
      "title": "MoniTor: Exploiting Large Language Models with Instruction for Online Video Anomaly Detection",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "南京航空航天大学",
      "author": "Shengtian Yang, Yue Feng, Yingshi Liu, Jingrou Zhang, Jie Qin",
      "workshop": ""
    },
    {
      "number": "C10",
      "title": "Learning to Generalize without Bias for Open-Vocabulary Action Recognition",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "西北工业大学",
      "author": "Yating Yu, Congqi Cao, Yifan Zhang, Yanning Zhang",
      "workshop": ""
    },
    {
      "number": "C11",
      "title": "DuCos: Duality Constrained Depth Super-Resolution via Foundation Model",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "新加坡国立大学",
      "author": "Zhiqiang Yan, Zhengxue Wang, Haoye Dong, Jun Li, Jian Yang, Gim Hee Lee",
      "workshop": ""
    },
    {
      "number": "C12",
      "title": "Penny-Wise and Pound-Foolish in AI-Generated Image Detection",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "哈尔滨工业大学",
      "author": "Yabin Wang, Zhiwu Huang, Zhou Su, Adam Prugel-Bennett, Xiaopeng Hong",
      "workshop": ""
    },
    {
      "number": "C13",
      "title": "V²-SAM: Marrying SAM2 with Multi-Prompt Experts for Cross-View Object Correspondence",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "清华大学",
      "author": "Jiancheng Pan, Runze Wang, Tianwen Qian, Mohammad Mahdi, Yanwei Fu, Xiangyang Xue, Xiaomeng Huang, Luc Van Gool, Danda Pani Paudel, Yuqian Fu",
      "workshop": ""
    },
    {
      "number": "C14",
      "title": "2D Gaussians Spatial Transport for Point-supervised Density Regression",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "哈尔滨工业大学",
      "author": "Miao Shang, Xiaopeng Hong",
      "workshop": ""
    },
    {
      "number": "C15",
      "title": "Revisiting RGBT Tracking Benchmarks From the Perspective of Modality Validity: A New Benchmark， Problem， and Solution",
      "qikan": "IEEE Transactions on Image Processing (TIP) 2025",
      "unit": "江南大学",
      "author": "Tianyang Xu, Xuefeng Zhu, Chunyang Cheng, Zhenhua Feng, Josef Kittler",
      "workshop": ""
    },
    {
      "number": "C16",
      "title": "Balancing Conservatism and Aggressiveness: Prototype-Affinity Hybrid Network for Few-Shot Segmentation",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "武汉理工大学",
      "author": "Tianyu Zou, Shengwu Xiong, Ruilin Yao, Yi Rong",
      "workshop": ""
    },
    {
      "number": "C17",
      "title": "Like Human Rethinking: Contour Transformer AutoRegression for Referring Remote Sensing Interpretation",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "西安电子科技大学",
      "author": "Jinming Chai, Licheng Jiao, Xiaoqiang Lu, Lingling Li, Fang Liu, Long Sun, Xu Liu, Wenping Ma, Weibin Li",
      "workshop": ""
    },
    {
      "number": "C18",
      "title": "Injecting Frame-Event Complementary Fusion into Diffusion for Optical Flow in Challenging Scenes",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "华中科技大学",
      "author": "Haonan Wang, Hanyu Zhou, Haoyue Liu, Luxin Yan",
      "workshop": ""
    },
    {
      "number": "C19",
      "title": "See through the Dark: Learning Illumination-affined Representations for Nighttime Occupancy Prediction",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "南京理工大学",
      "author": "Yuan Wu, Zhiqiang Yan, Yigong Zhang, Xiang Li, Jian Yang",
      "workshop": ""
    },
    {
      "number": "C20",
      "title": "Physical Regularization Loss: Integrating Physical Knowledge to Image Segmentation",
      "qikan": "International Journal of Computer Vision (IJCV) 2026",
      "unit": "重庆邮电大学",
      "author": "Yan Ding, Shuang Li, Huafeng Li, Guanqiu Qi, Yunpeng Gong, Zhiqin Zhu",
      "workshop": ""
    },
    {
      "number": "C21",
      "title": "Weakly Supervised Dynamic Scene Graph Generation with Temporal-enhanced Relation-aware Knowledge Transferring",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "北京大学",
      "author": "Zhu Xu, Ting Lei, Zhimin Li, Guan Wang, Qingchao Chen, Yuxin Peng, Yang Liu",
      "workshop": ""
    },
    {
      "number": "C23",
      "title": "RAGTrack: Language-aware RGBT Tracking with Retrieval-Augmented Generation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "陆军工程大学/大连理工大学",
      "author": "Hao Li, Yuhao Wang, Wenning Hao, Pingping Zhang, Dong Wang, Huchuan Lu",
      "workshop": ""
    },
    {
      "number": "C24",
      "title": "Tracking the Unstable: Appearance-Guided Motion Modeling for Robust Multi-Object Tracking in UAV-Captured Videos",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "中国科学院大学、中国科学院光电技术研究所",
      "author": "Jianbo Ma, Hui Luo, Qi Chen, Yuankai Qi, Yumei Sun, Amin Beheshti, Jianlin Zhang, Ming-Hsuan Yang",
      "workshop": ""
    },
    {
      "number": "C25",
      "title": "MCMoE: Completing Missing Modalities with Mixture of Experts for Incomplete Multimodal Action Quality Assessment",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "福州大学",
      "author": "Huangbiao Xu, Huanqi Wu, Xiao Ke, Junyi Wu, Rui Xu, Jinglin Xu",
      "workshop": ""
    },
    {
      "number": "C26",
      "title": "Seeing Through the Noise: Improving Infrared Small Target Detection and Segmentation from Noise Suppression Perspective",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "北京航空航天大学",
      "author": "Maoxun Yuan, Duanni Meng, Ziteng Xi, Tianyi Zhao, Shiji Zhao, Yimian Dai, Xingxing Wei",
      "workshop": ""
    },
    {
      "number": "C27",
      "title": "ProPL: Universal Semi-Supervised Ultrasound Image Segmentation via Prompt-Guided Pseudo-Labeling",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "武汉理工大学",
      "author": "Yaxiong Chen, Qicong Wang, Chunlei Li, Jingliang Hu, Yilei Shi, Shengwu Xiong, Xiaoxiang Zhu, Lichao Mou",
      "workshop": ""
    },
    {
      "number": "C28",
      "title": "Detecting-AI-Generated-Forgeries-via-Iterative-Manifold-Deviation-Amplification",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "武汉理工大学",
      "author": "Jiangling Zhang, Shuxuan Gao, Bofan Liu, Siqiang Feng, Jirui Huang, Yaxiong Chen, Ziyu Chen",
      "workshop": ""
    },
    {
      "number": "C29",
      "title": "Accident Anticipation via Temporal Occurrence Prediction",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "武汉大学",
      "author": "Tianhao Zhao, Yiyang Zou, Zihao Mao, Peilun Xiao, Yulin Huang, Hongda Yang, Yuxuan Li, Qun Li, Guobin Wu, Yutian Lin",
      "workshop": ""
    },
    {
      "number": "C30",
      "title": "PhysPatch: A Physically Realizable and Transferable Adversarial Patch Attack for Multimodal Large Language Models-based Autonomous Driving Systems",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "西安交通大学",
      "author": "Qi Guo, Xiaojun Jia, Shanmin Pang, Simeng Qin, Lin Wang, Ju Jia, Yang Liu, Qing Guo",
      "workshop": ""
    },
    {
      "number": "C31",
      "title": "Polyline Path Masked Attention for Vision Transformer",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "西安交通大学",
      "author": "Zhongchen Zhao, Chaodong Xiao, Hui Lin, Qi Xie, Lei Zhang, Deyu Meng",
      "workshop": ""
    },
    {
      "number": "C32",
      "title": "DC-SAM: In-Context Segment Anything in Images and Videos via Dual Consistency",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "北京邮电大学",
      "author": "Mengshi Qi, Pengfei Zhu, Xiangtai Li, Xiaoyang Bi, Lu Qi, Huadong Ma, Ming-Hsuan Yang",
      "workshop": ""
    },
    {
      "number": "C33",
      "title": "Breaking Task Boundaries: A Unified Model for 3D Medical Image Fusion and Segmentation Guided by Manifold Perspective",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "大连民族大学",
      "author": "Zeyu Wang, Jiayu Wang, Haiyu Song",
      "workshop": ""
    },
    {
      "number": "C34",
      "title": "Fair Deepfake Detectors Can Generalize",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "新加坡国立大学",
      "author": "Xuanang Cheng, Minghui Liu, Yangyang Guo, Tianyi Wang, Liqiang Nie, Mohan Kankanhalli",
      "workshop": ""
    },
    {
      "number": "C35",
      "title": "TP-Seg: Task-Prototype Framework for Unified Medical Lesion Segmentation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "江西师范大学",
      "author": "Jiawei Xu, Qiangqiang Zhou, Dandan Zhu, Yong Chen, Yugen Yi, Xiaoqi Zhao",
      "workshop": ""
    },
    {
      "number": "C36",
      "title": "RaGS: Unleashing 3D Gaussian Splatting from 4D Radar and Monocular Cue for 3D Object Detection",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "浙江大学",
      "author": "Xiaokai Bai, Chenxu Zhou, Lianqing Zheng, Siyuan Cao, Jianan Liu, Xiaohan Zhang, Yiming Li, Zhengzhuang Zhang, Huiliang Shen",
      "workshop": ""
    },
    {
      "number": "C37",
      "title": "Customized Fusion: A Closed-Loop Dynamic Network for Adaptive Multi-Task-Aware Infrared-Visible Image Fusion",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "合肥工业大学",
      "author": "Zengyi Yang, Yu Liu, Juan Cheng, Zhiqin Zhu, Yafei Zhang, Huafeng Li",
      "workshop": ""
    },
    {
      "number": "C38",
      "title": "Uncertainty-Aware Modality Fusion for Unaligned RGB-T Salient Object Detection",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "天津理工大学",
      "author": "Mianzhao Wang, Fan Shi, Xu Cheng, Chen Jia, Shengyong Chen",
      "workshop": ""
    },
    {
      "number": "C39",
      "title": "ResProto-FD: Visual-Language Residual Prototype Sets for Generalized Face Forgery Detection",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "西安电子科技大学",
      "author": "Jiuyao Jing, Yu Zheng, Chunlei Peng",
      "workshop": ""
    },
    {
      "number": "C40",
      "title": "Event-based Tiny Object Detection: A Benchmark Dataset and Baselines",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "国防科技大学",
      "author": "Nuo Chen, Chao Xiao, Yimian Dai, Shiman He, Miao Li, Wei An",
      "workshop": ""
    },
    {
      "number": "C41",
      "title": "Interpretable Subspace Clustering",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "安徽大学",
      "author": "Peng Zhou, Aiting Yao, Liang Du, Xinwang Liu",
      "workshop": ""
    },
    {
      "number": "C42",
      "title": "Revisiting Token Compression for Accelerating ViT-based Sparse Multi-View 3D Object Detectors",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京理工大学",
      "author": "Mingqian Ji, Shanshan Zhang, Jian Yang",
      "workshop": ""
    },
    {
      "number": "C43",
      "title": "CrossHOI: Learning Cross-View Representations for Monocular 3D Human-Object Interaction Reconstruction",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京理工大学",
      "author": "Pei Geng, Shanshan Zhang, Jian Yang",
      "workshop": ""
    },
    {
      "number": "C44",
      "title": "FSLoRA: Harmonizing Detection and Re-Identification via Freq-Spatial Low-Rank Adapter for One-Stage Person Search",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京理工大学",
      "author": "Yanling Tian, Shanshan Zhang, Di Chen, Jian Yang",
      "workshop": ""
    },
    {
      "number": "C45",
      "title": "FB-CLIP: Fine-Grained Zero-Shot Anomaly Detection with Foreground-Background Disentanglement",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中国科学院西安光学精密机械研究所",
      "author": "Ming Hu, Yongsheng Huo, Mingyu Dou, Jianfu Yin, Peng Zhao, Yao Wang, Cong Hu, Bingliang Hu, Quan Wang",
      "workshop": ""
    },
    {
      "number": "C47",
      "title": "UMDATrack: Unified Multi-Domain Adaptive Tracking Under Adverse Weather Conditions",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "中山大学",
      "author": "Siyuan Yao, Rui Zhu, Ziqi Wang, Wenqi Ren, Yanyang Yan, Xiaochun Cao",
      "workshop": ""
    },
    {
      "number": "C48",
      "title": "GSV2X: Geometry-Aware Uncertainty Modeling and Orthogonal Fusion for Robust Roadside Perception",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京理工大学",
      "author": "Jianqiang Xu, Gensheng Pei",
      "workshop": ""
    },
    {
      "number": "C49",
      "title": "Beyond Quadratic: Linear-Time Change Detection with RWKV",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "南京理工大学",
      "author": "Zhenyu Yang, Gensheng Pei, Tao Chen, Xia Yuan, Haofeng Zhang, Xiangbo Shu, Yazhou Yao",
      "workshop": ""
    },
    {
      "number": "C50",
      "title": "Fine-grained Image Quality Assessment for Perceptual Image Restoration",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "西安电子科技大学",
      "author": "Xiangfei Sheng, Xiaofeng Pan, Zhichao Yang, Pengfei Chen, Leida Li",
      "workshop": ""
    },
    {
      "number": "C51",
      "title": "FRBNet: Revisiting Low-light Vision through Frequency-Domain Radial Basis Network",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "智能博弈与决策实验室，国防科技大学",
      "author": "Fangtong Sun, Congyu Li, Ke Yang, Yuchen Pan, Hanwen Yu, Xichuan Zhang, Yiying Li",
      "workshop": ""
    },
    {
      "number": "C52",
      "title": "Spike Camera Optical Flow Estimation Based on Continuous Spike Streams",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "南洋理工大学",
      "author": "Rui Zhao, Ruiqin Xiong, Dongkai Wang, Shiyu Xuan, Jian Zhang, Xiaopeng Fan, Tiejun Huang",
      "workshop": ""
    },
    {
      "number": "C53",
      "title": "Reframing Long-Tailed Learning via Loss Landscape Geometry",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "山东大学",
      "author": "Chenghan Chen, Yiming Liu, Yanzhen Wang, Yujia Wang, Xiankai Lu",
      "workshop": ""
    },
    {
      "number": "C54",
      "title": "SPEGC: Continual Test-Time Adaptation via Semantic-Prompt-Enhanced Graph Clustering for Medical Image Segmentation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "陕西科技大学",
      "author": "Xiaogang Du, Jiawei Zhang, Tongfei Liu, Tao Lei, Yingbo Wang",
      "workshop": ""
    },
    {
      "number": "C55",
      "title": "Point2RBox-v3: Self-Bootstrapping from Point Annotations via Integrated Pseudo-Label Refinement and Utilization",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "华南理工大学",
      "author": "Teng Zhang, Ziqian Fan, Mingxin Liu, Xin Zhang, Xudong Lu, Wentong Li, Yue Zhou, Yi Yu, Xiang Li, Junchi Yan, Xue Yang",
      "workshop": ""
    },
    {
      "number": "C57",
      "title": "WeDetect: Fast Open-Vocabulary Object Detection as Retrieval",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中山大学，微信",
      "author": "Shenghao Fu, Yukun Su, Fengyun Rao, Jing Lv, Xiaohua Xie, Weishi Zheng",
      "workshop": ""
    },
    {
      "number": "C58",
      "title": "Fourier Angle Alignment for Oriented Object Detection in Remote Sensing",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "北京理工大学",
      "author": "Changyu Gu, Linwei Chen, Lin Gu, Ying Fu",
      "workshop": ""
    },
    {
      "number": "C59",
      "title": "VRCLIP: Multimodal Canonical Correlation Alignment for CLIP-Driven Vision-Radio Person Re-Identification",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中国科学技术大学",
      "author": "Rui Zhang, Yaqi Wang, Yadong Li, Ruixu Geng, Jianyang Wang, Qijun Ying, Dongheng Zhang, Yang Hu, Yan Chen",
      "workshop": ""
    },
    {
      "number": "C60",
      "title": "FROM SPARSE TO DENSE: SPATIO-TEMPORAL FUSION FOR MULTI-VIEW 3D HUMAN POSE ESTIMATION WITH DENSEWARPER",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "清华大学",
      "author": "Ling Li, Changjie Chen, Yuyan Wang, Jiaqing Lv, Genglun Zhang, Yiyun Chen, Zhidong Deng",
      "workshop": ""
    },
    {
      "number": "C61",
      "title": "PD2GS: Part-Level Decoupling and Continuous Deformation of Articulated Objects via Gaussian Splatting",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "北京邮电大学",
      "author": "Haowen Wang, Xiaoping Yuan, Zhao Jin, Zhen Zhao, Zhengping Che, Yousong Xue, Jing Tian, Yakun Huang, Jian Tang",
      "workshop": ""
    },
    {
      "number": "C62",
      "title": "Fine-Grained Generalization via Structuralizing Concept and Feature Space into Commonality， Specificity and Confounding",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "河北工业大学",
      "author": "Zhen Wang, Jiaojiao Zhao, Qilong Wang, Yongfeng Dong, Wenlong Yu",
      "workshop": ""
    },
    {
      "number": "C63",
      "title": "BuildingGPT: Auto-Regressive Building Wireframe Reconstruction Model with Reinforcement Learning",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中国科学院自动化研究所",
      "author": "Yuzhou Liu, Lingjie Zhu, Hanqiao Ye, Yujun Liu, Shangfeng Huang, Xiang Gao, Ruisheng Wang, Shuhan Shen",
      "workshop": ""
    },
    {
      "number": "C64",
      "title": "Structural Similarity in Deep Features: Unified Image Quality Assessment Robust to Geometrically Disparate Reference",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "河南师范大学（论文单位福州大学，系展示者博士期间工作）",
      "author": "Keke Zhang, Weiling Chen, Tiesong Zhao, Zhou Wang",
      "workshop": ""
    },
    {
      "number": "D01",
      "title": "From Pixels to Views: Learning Angular-Aware and Physics-Consistent Representations for Light Field Microscopy",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "中国科学技术大学",
      "author": "Feng He",
      "workshop": ""
    },
    {
      "number": "D02",
      "title": "All-day Multi-scenes Lifelong Vision-and-Language Navigation with Tucker Adaptation",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "中国科学院沈阳自动化研究所",
      "author": "Xudong Wang, Gan Li, Zhiyu Liu, Yao Wang, Lianqing Liu, Zhi Han",
      "workshop": ""
    },
    {
      "number": "D03",
      "title": "Class-wise Balancing Data Replay for Federated Class-Incremental Learning",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "山东大学",
      "author": "Zhuang Qi, Yu Pan, Lei Meng, Sijin Zhou, Han Yu, Xiaoxiao Li, Xiangxu Meng",
      "workshop": ""
    },
    {
      "number": "D04",
      "title": "FilterFL: Knowledge Filtering-based Data-Free Backdoor Defense  for Federated Learning",
      "qikan": "ACM SIGSAC Conference on Computer and Communications Security (ACM CCS) 2025",
      "unit": "华东师范大学",
      "author": "Yanxin Yang, Ming Hu, Xiaofei Xie, Yue Cao, Yihao Huang, Pengyu Zhang, Mingsong Chen",
      "workshop": ""
    },
    {
      "number": "D05",
      "title": "Complementary Text-Guided Attention for Zero-Shot Adversarial Robustness",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "天津理工大学",
      "author": "Lu Yu, Haiyang Zhang, Changsheng Xu",
      "workshop": ""
    },
    {
      "number": "D06",
      "title": "External Knowledge Injection for CLIP-Based Class-Incremental Learning",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "南京大学",
      "author": "Dawei Zhou, Kaiwen Li, Jingyi Ning, Hanjia Ye, Lijun Zhang, Dechuan Zhan",
      "workshop": ""
    },
    {
      "number": "D07",
      "title": "U2UData+: A Scalable Swarm UAVs Autonomous Flight Dataset for Embodied Long-horizon Tasks",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "清华大学",
      "author": "Tongtong Feng, Xin Wang, Feilin Han, Leping Zhang, Wenwu Zhu",
      "workshop": ""
    },
    {
      "number": "D08",
      "title": "DuetMerging: Synergizing Dynamic and Static Strategies for Mitigating Task Interference in Model Merging",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "鹏城实验室",
      "author": "Yan Li, Guiping Cao, Yaguang Song, Ming Tao, Haoran Gong, Junhui Liu, Yaowei Wang, Dongmei Jiang",
      "workshop": ""
    },
    {
      "number": "D09",
      "title": "SimScale: Learning to Drive via Real-World Simulation at Scale",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "自动化所多模态国重，香港大学，小米汽车",
      "author": "Haochen Tian, Tianyu Li, Haochen Liu, Jiazhi Yang, Yihang Qiu, Guang Li, Junli Wang, Yinfeng Gao, Zhang Zhang, Liang Wang, Hangjun Ye, Long Chen, Hongyang Li",
      "workshop": ""
    },
    {
      "number": "D10",
      "title": "FedBPrompt: Federated Domain Generalization Person Re-Identification via Body Distribution Aware Visual Prompts",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "武汉科技大学",
      "author": "Xin Xu, Weilong Li, Wei Liu, Wenke Huang, Zhixi Yu, Bin Yang, Xiaoying Liao, Kui Jiang",
      "workshop": ""
    },
    {
      "number": "D11",
      "title": "Relieving the Over-Aggregating Effect in Graph Transformers",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "中国科学院计算技术研究所",
      "author": "Juanshu Sun, Wanxing Chang, Chenxue Yang, Qingming Huang, Shuhui Wang",
      "workshop": ""
    },
    {
      "number": "D12",
      "title": "Learning pattern-specific experts for time series forecasting under patch-level distribution shift",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "天津大学",
      "author": "Yanru Sun, Zongxia Xie, Emadeldeen Eldele, Dongyue Chen, Qinghua Hu, Min Wu",
      "workshop": ""
    },
    {
      "number": "D13",
      "title": "CA2C: A Prior-Knowledge-Free Approach for Robust Label Noise Learning via Asymmetric Co-learning and Co-training",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "南京理工大学",
      "author": "Mengmeng Sheng, Zeren Sun, Tianfei Zhou, Xiangbo Shu, Jinshan Pan, Yazhou Yao",
      "workshop": ""
    },
    {
      "number": "D14",
      "title": "Federated Clinical Concept and Disease Semantic Learning for Congenital Heart Disease Diagnosis",
      "qikan": "npj Digital Medicine 2026",
      "unit": "武汉大学",
      "author": "Wenke Huang, Yangxu Liao, Wenjia Lei, Guancheng Wan, Xuankun Rong, Chi Wen, He Li, Mang Ye, Qingqing Wu, Bo Du",
      "workshop": ""
    },
    {
      "number": "D15",
      "title": "One Object， Multiple Lies: A Benchmark for Cross-task Adversarial Attack on Unified Vision-Language Models",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "同济大学",
      "author": "Jiale Zhao, Xinyang Jiang, Junyao Gao, Yuhao Xue, Cairong Zhao",
      "workshop": ""
    },
    {
      "number": "D16",
      "title": "Graph Meets Deep Unfolding: An Interpretable Mutual-benefit Multi-view Learning Network",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "电子科技大学",
      "author": "Renjie Lin, Hongzhi He, Yilin Wu, Shide Du, Le Zhang",
      "workshop": ""
    },
    {
      "number": "D17",
      "title": "Flow Matching for Few-Trial Neural Adaptation with Stable Latent Dynamics",
      "qikan": "International Conference on Machine Learning (ICML) 2025",
      "unit": "浙江大学",
      "author": "Puli Wang, Yu Qi, Yueming Wang, Gang Pan",
      "workshop": ""
    },
    {
      "number": "D18",
      "title": "Language Guided Concept Bottleneck Models for Interpretable Continual Learning",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2025",
      "unit": "天津理工大学",
      "author": "Lu Yu, Haoyu Han, Zhe Tao, Hantao Yao, Changsheng Xu",
      "workshop": ""
    },
    {
      "number": "D19",
      "title": "When Large Multimodal Models Confront Evolving Knowledge: Challenges and Explorations",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "北京通用人工智能研究院",
      "author": "Kailin Jiang, Yuntao Du, Yukai Ding, Yuchen Ren, Ning Jiang, Zhi Gao, Zilong Zheng, Lei Liu, Bin Li, Qing Li",
      "workshop": ""
    },
    {
      "number": "D20",
      "title": "SIDE: Surrogate Conditional Data Extraction from Diffusion Models",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "复旦大学",
      "author": "Yunhao Chen, Shujie Wang, Difan Zou, Xingjun Ma",
      "workshop": ""
    },
    {
      "number": "D21",
      "title": "Mind the Gap: Preserving and Compensating for the Modality Gap in CLIP-Based Continual Learning",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "南开大学",
      "author": "Linlan Huang, Xusheng Cao, Haori Lu, Yifan Meng, Fei Yang, Xialei Liu",
      "workshop": ""
    },
    {
      "number": "D22",
      "title": "WHU-MARS: A Multispectral Aerial-Ground Benchmark Towards Any-Scenario Person Re-Identification",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "武汉大学",
      "author": "Yuxuan Zhao, Bin Yang, Zhongao Zhou, He Li, Jian Liang, Jun Chen, Bo Du, Mang Ye",
      "workshop": ""
    },
    {
      "number": "D23",
      "title": "Semantic Shift Estimation via Dual-Projection and Classifier Reconstruction for Exemplar-Free Class-Incremental Learning",
      "qikan": "International Conference on Machine Learning (ICML) 2025",
      "unit": "华南理工大学",
      "author": "Run He, Di Fang, Yicheng Xu, Yawen Cui, Ming Li, Cen Chen, Ziqian Ceng, Huiping Zhuang",
      "workshop": ""
    },
    {
      "number": "D24",
      "title": "L3A: Label-Augmented Analytic Adaptation for Multi-Label Class Incremental Learning",
      "qikan": "International Conference on Machine Learning (ICML) 2025",
      "unit": "华南理工大学",
      "author": "Xiang Zhang, Run He, Jiao Chen, Di Fang, Ming Li, Ziqian Ceng, Cen Chen, Huiping Zhuang",
      "workshop": ""
    },
    {
      "number": "D25",
      "title": "The Lie of the Average: How Class Incremental Learning Evaluation Deceives You?",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "南京大学",
      "author": "Guannan Lai, Dawei Zhou, Xin Yang, Hanjia Ye",
      "workshop": ""
    },
    {
      "number": "D26",
      "title": "Surrogate Deep Neural Networks Reveal Hierarchical Handwriting Encoding in Human Motor Cortex",
      "qikan": "Cell Reports 2026",
      "unit": "浙江大学",
      "author": "Jiajun Chen, Tianqi Xu, Xinzhu Xiong, Xiaomeng Yang, Yueming Wang, Yu Qi",
      "workshop": ""
    },
    {
      "number": "D27",
      "title": "Unbiased Rectification for Sequential Recommender Systems Under Fake Orders",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "华中科技大学",
      "author": "Qiyu Qin, Yichen Li, Haozhao Wang, Cheng Wang, Rui Zhang, Ruixuan Li",
      "workshop": ""
    },
    {
      "number": "D28",
      "title": "Robust-R1: Degradation-Aware Reasoning for Robust Visual Understanding",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "香港科技大学",
      "author": "Jiaqi Tang, Jianmin Chen, Wei Wei, Xiaogang Xu, Runtao Liu, Xiangyu Wu, Qipeng Xie, Jiafei Wu, Lei Zhang, Qifeng Chen",
      "workshop": ""
    },
    {
      "number": "D29",
      "title": "Revisiting Neural Networks for Few-Shot Learning: A Zero-Cost NAS Perspective",
      "qikan": "International Conference on Machine Learning (ICML) 2025",
      "unit": "东北大学",
      "author": "Haidong Kang",
      "workshop": ""
    },
    {
      "number": "D30",
      "title": "Gains: Fine-grained Federated Domain Adaptation in Open Set",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "国防科技大学",
      "author": "Zhengyi Zhong, Wenzheng Jiang, Weidong Bao, Ji Wang, Qi Wang, Guanbo Wang, Yongheng Deng, Ju Ren",
      "workshop": ""
    },
    {
      "number": "D31",
      "title": "Dual-Estimator: Decoupling Global and Local Semantic Shift for Drift Compensation in Class-Incremental Learning",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京理工大学",
      "author": "Fankang Xu, Lu Jin, Yanpeng Sun, Shiyu Xuan, Zechao Li",
      "workshop": ""
    },
    {
      "number": "D33",
      "title": "HiF-VLA: Hindsight， Insight and Foresight through Motion Representation for Vision-Language-Action Models",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "西湖大学",
      "author": "Minghui Lin",
      "workshop": ""
    },
    {
      "number": "D34",
      "title": "PhysReason: A Comprehensive Benchmark towards Physics-Based Reasoning",
      "qikan": "Annual Meeting of the Association for Computational Linguistics (ACL) 2025",
      "unit": "西安交通大学",
      "author": "Xinyu Zhang, Yuxuan Dong, Yanrui Wu, Jiaxing Huang, Chengyou Jia, Fernando Basura, Shou Mike Zheng, Lingling Zhang, Jun Liu",
      "workshop": ""
    },
    {
      "number": "D35",
      "title": "Policy Contrastive Decoding for Robotic Foundation Models",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "西南交通大学",
      "author": "Shihan Wu, Xu Luo, Ji Zhang, Junlin Xie, Jingkuan Song, Hengtao Shen, Lianli Gao",
      "workshop": ""
    },
    {
      "number": "D36",
      "title": "LENS: Multi-level Evaluation of Multimodal Reasoning with Large Language Models",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "武汉理工大学",
      "author": "Ruilin Yao, Bo Zhang, Jirui Huang, Xinwei Long, Yifang Zhang, Tianyu Zou, Shili Xiong, Yi Rong, Yufei Wu, Shichao Su, Yifan Xu, Wenqian Ceng, Zhaoyu Yang, Guoyou Li, Shilan Zhang, Zichan Li, Yaxiong Chen, Shengwu Xiong, Peng Xu, Jiajun Zhang, Bowen Zhou, David A. Clifton, Luc Van Gool",
      "workshop": ""
    },
    {
      "number": "D37",
      "title": "DepthVanish: Optimizing Adversarial Interval Structures for Stereo-Depth-Invisible Patches",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "University of Alberta",
      "author": "Yun Xing, Yue Cao, Nhat Chung, Jie Zhang, Ivor Tsang, Mingming Chen, Yang Liu, Lei Ma, Qing Guo",
      "workshop": ""
    },
    {
      "number": "D38",
      "title": "Evidential Deep Partial Label Learning to Quantify Disambiguation Uncertainty",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "青岛大学",
      "author": "Jinfu Fan, Jiangnan Li, Xiaohui Zhong, Kangrui Ren, Zhencun Jiang, Min Gan, Tianhao Gu, Linqing Huang",
      "workshop": ""
    },
    {
      "number": "D39",
      "title": "GMMamba: Group Masking Mamba for Whole Slide Image Classification",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "哈尔滨工业大学",
      "author": "Tingting Zheng, Hongxun Yao, Kui Jiang, Sicheng Zhao, Yi Xiao",
      "workshop": ""
    },
    {
      "number": "D40",
      "title": "MedKCO: Medical Vision-Language Pretraining via Knowledge-Driven Cognitive Orchestration",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "东南大学",
      "author": "Chenran Zhang, Ruiqi Wu, Tao Zhou, Yi Zhou",
      "workshop": ""
    },
    {
      "number": "D41",
      "title": "Evolving and Regularizing Meta-Environment Learner for Fine-Grained Few-Shot Class-Incremental Learning",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "山东大学",
      "author": "Lijun Zhao, Zhenduo Chen, Yongxin Wang, Xin Luo, Xinshun Xu",
      "workshop": ""
    },
    {
      "number": "D42",
      "title": "Socialized Coevolution: Advancing a Better World through Cross-Task Collaboration",
      "qikan": "International Conference on Machine Learning (ICML) 2025",
      "unit": "天津大学",
      "author": "Xinjie",
      "workshop": ""
    },
    {
      "number": "D43",
      "title": "HTNav: A Hybrid Navigation Framework with Tiered Structure for Urban Aerial Vision-and-Language Navigation.",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京航空航天大学",
      "author": "Chengjie Fan, Cong Pan, Zijian Liu, Ningzhong Liu, Jie Qin",
      "workshop": ""
    },
    {
      "number": "D44",
      "title": "Fractional-order Spiking Neural Network",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "中国科学技术大学",
      "author": "Chengjie Ge, Yufeng Peng, Zihao Li, Qiyu Kang, Xueyang Fu, Xuhao Li, Qixin Zhang, Junhao Ren, Zheng-jun Zha",
      "workshop": ""
    },
    {
      "number": "D45",
      "title": "Priorrg: Prior-guided contrastive pre-training and coarse-to-fine decoding for chest x-ray report generation",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "西安电子科技大学",
      "author": "Kang Liu, Zhuoqi Ma, Zikang Fang, Yunan Li, Kun Xie, Qiguang Miao",
      "workshop": ""
    },
    {
      "number": "D46",
      "title": "QuantSparse: Comprehensively Compressing Video Diffusion Transformer with Model Quantization and Attention Sparsification",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "中国科学院计算技术研究所",
      "author": "Weilun Feng, Chuanguang Yang, Haotong Qin, Mingqiang Wu, Yuqi Li, Xiangqi Li, Zhulin An, Lipo Huang, Yulun Zhang, Michele Magno, Yongjun Xu",
      "workshop": ""
    },
    {
      "number": "D47",
      "title": "Quantized Visual Geometry Grounded Transformer",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "中国科学院计算技术研究所",
      "author": "Weilun Feng, Haotong Qin, Mingqiang Wu, Chuanguang Yang, Yuqi Li, Xiangqi Li, Zhulin An, Lipo Huang, Yulun Zhang, Michele Magno, Yongjun Xu",
      "workshop": ""
    },
    {
      "number": "D48",
      "title": "VUDG: A DATASET FOR VIDEO UNDERSTANDING DOMAIN GENERALIZATION",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "北京理工大学计算机学院",
      "author": "Ziyi Wang, Zhi Gao, Boxuan Yu, Zirui Dai, Peiyao Wang, Yuxiang Song, Qingyuan Lu, Jin Chen, Xinxiao Wu",
      "workshop": ""
    },
    {
      "number": "D49",
      "title": "FAVOR-Bench: A Comprehensive Benchmark for Fine-Grained Video Motion Understanding",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "复旦大学",
      "author": "Chongjun Tu, Lin Zhang, Pengtao Chen, Peng Ye, Xianfang Ceng, Wei Cheng, Gang Yu, Tao Chen",
      "workshop": ""
    },
    {
      "number": "D50",
      "title": "From pretraining to privacy: federated ultrasound foundation model with self- supervised learning",
      "qikan": "npj Digital Medicine 2025",
      "unit": "四川大学华西医院",
      "author": "Yuncheng Jiang, Chunmei Feng, Jinke Ren, Jun Wei, Zixun Zhang, Yiwen Hu, Yunbi Liu, Rui Sun, Xuemei Tang, Juan Du, Xiang Wan, Yong Xu, Bo Du, Xin Gao, Guangyu Wang, Shaohua Zhou, Shuguang Cui, Zhen Li",
      "workshop": ""
    },
    {
      "number": "D51",
      "title": "Bilevel Optimization for Adversarial Learning Problems: Sharpness， Generation， and Beyond",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "大连理工大学",
      "author": "Risheng Liu, Zhu Liu, Weihao Mao, Wei Yao, Jin Zhang",
      "workshop": ""
    },
    {
      "number": "D52",
      "title": "IDER: Idempotent Experience Replay for Reliable Continual Learning",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "上海交通大学",
      "author": "Zhanwang Liu, Yuting Li, Haoyuan Gao, Yexin Li, Linghe Kong, Lichao Sun, Weiran Huang",
      "workshop": ""
    },
    {
      "number": "D53",
      "title": "Harnessing Textual Semantic Priors for Knowledge Transfer and Refinement in CLIP-Driven Continual Learning",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "西安电子科技大学",
      "author": "Lingfeng He, De Cheng, Di Xu, Huaijie Wang, Nannan Wang",
      "workshop": ""
    },
    {
      "number": "D54",
      "title": "StPR: Spatiotemporal Preservation and Routing for Exemplar-Free Video Class-Incremental Learning",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "西安电子科技大学",
      "author": "Huaijie Wang, De Cheng, Guozhang Li, Zhipeng Xu, Lingfeng He, Jie Li, Nannan Wang, Xinbo Gao",
      "workshop": ""
    },
    {
      "number": "D55",
      "title": "CoPINN: Cognitive Physics-Informed Neural Networks",
      "qikan": "International Conference on Machine Learning (ICML) 2025",
      "unit": "四川大学",
      "author": "Siyuan Duan, Wenyuan Wu, Peng Hu, Zhenwen Ren, Dezhong Peng, Yuan Sun",
      "workshop": ""
    },
    {
      "number": "D56",
      "title": "Rising from Ashes: Generalized Federated Learning via Dynamic Parameter Reset",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "华东师范大学",
      "author": "Jiahao Wu, Ming Hu, Yanxin Yang, Zekai Chen, Chenyu Song, Mingsong Chen",
      "workshop": ""
    },
    {
      "number": "D57",
      "title": "UniM: A Unified Any-to-Any Interleaved Multimodal Benchmark",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "National University of Singapore",
      "author": "Yanlin Li, Minghui Guo, Kaiwen Zhang, Shize Zhang, Yiran Zhao, Haodong Li, Congyue Zhou, Weijie Zheng, Yushen Yan, Shengqiong Wu, Wei Ji, Lei Cui, Furu Wei, Hao Fei, Mong-Li Lee, Wynne Hsu",
      "workshop": ""
    },
    {
      "number": "D58",
      "title": "Physics-Informed Matrix Factorization Operator",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "西安电子科技大学人工智能学院",
      "author": "Wenming Wu, Chenxi Tian, Licheng Jiao, Lingling Li, Xu Liu, Fang Liu, Wenping Ma, Shuyuan Yang",
      "workshop": ""
    },
    {
      "number": "D59",
      "title": "Beyond the Seen: Bounded Distribution Estimation for Open-Vocabulary Learning",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "北京理工大学",
      "author": "Xiaomeng Fan, Wei Wu, Zhi Gao, Yuwei Wu, Jin Chen, Yunde Jia",
      "workshop": ""
    },
    {
      "number": "D60",
      "title": "Is your VLM Sky-Ready? A Comprehensive Spatial Intelligence Benchmark for UAV Navigation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "清华大学",
      "author": "Lingfeng Zhang, Yuchen Zhang, Hongsheng Li, Haoxiang Fu, Yingbo Tang, Hangjun Ye, Long Chen, Xiaojun Liang, Xiaoshuai Hao, Wenbo Ding",
      "workshop": ""
    },
    {
      "number": "D61",
      "title": "VecFormer: Towards Efficient and Generalizable Graph Transformer with Graph Token Attention",
      "qikan": "International World Wide Web Conference (WWW) 2026",
      "unit": "浙江大学，西湖大学",
      "author": "Jingbo Zhou, Jun Xia, Siyuan Li, Yunfan Liu, Wenjun Wang, Yufei Huang, Changxi Chi, Mutian Hong, Zhuoli Ouyang, Shu Wang, Zhongqi Wang, Xingyu Wu, Chang Yu, Ziqing Li",
      "workshop": ""
    },
    {
      "number": "D62",
      "title": "CDBridge: A Cross-omics Post-training Bridge Strategy for Context-aware Biological Modeling",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "西湖大学",
      "author": "Chang Yu, Siyuan Li, Zicheng Liu, Jingbo Zhou, Xianglong Guo, Kai Yu, Yuqing Zhou, Ken Li, Zelin Zang, Zhen Lei, Stan Z. Li",
      "workshop": ""
    },
    {
      "number": "E01",
      "title": "Revisiting Generative Infrared and Visible Image Fusion Based on Human Cognitive Laws",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "江南大学",
      "author": "Lin Guo, Xiaoqing Luo, Wei Xie, Zhancheng Zhang, Hui Li, Rui Wang, Zhenhua Feng, Xiaoning Song",
      "workshop": ""
    },
    {
      "number": "E02",
      "title": "Latent Knowledge-Guided Video Diffusion for Scientific Phenomena Generation from a Single Initial Frame",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "上海交通大学 宁波东方理工大学",
      "author": "Qinglong Cao, Xirui Li, Ding Wang, Chao Ma, Yuntian Chen, Xiaokang Yang",
      "workshop": ""
    },
    {
      "number": "E03",
      "title": "CoEmoGen: Towards Semantically-Coherent and Scalable Emotional Image Content Generation",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "香港科技大学（广州）",
      "author": "Kaishen Yuan, Yuting Zhang, Shang Gao, Yijie Zhu, Wenshuo Chen, Yutao Yue",
      "workshop": ""
    },
    {
      "number": "E04",
      "title": "Unleashing the Potential of Large Language Models for Text-to-Image Generation through Autoregressive Representation Alignment",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "中国科学院沈阳自动化研究所",
      "author": "Xing Xie, Jiawei Liu, Ziyue Lin, Zhi Han, Huijie Fan, Yandong Tang, Jingqiong Qu",
      "workshop": ""
    },
    {
      "number": "E05",
      "title": "Decision Boundary-aware Generation for Long-tailed Learning",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "厦门大学",
      "author": "Jiacheng Yang, Ruichi Zhang, Chikai Shang, Mengke Li, Xinyi Shang, Junlong Gao, Yonggang Zhang, Yang Lu",
      "workshop": ""
    },
    {
      "number": "E06",
      "title": "OmniLottie: Generating Vector Animations via Parameterized Lottie Tokens",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "复旦大学",
      "author": "Yiying Yang, Wei Cheng, Sijin Chen, Honghao Fu, Xianfang Ceng, Yujun Cai, Gang Yu, Xingjun Ma",
      "workshop": ""
    },
    {
      "number": "E07",
      "title": "TongUI: Internet-Scale Trajectories from Multimodal Web Tutorials for Generalized GUI Agents",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "北京理工大学， 北京通用人工智能研究院",
      "author": "Bofei Zhang, Zirui Shang, Zhi Gao, Wang Zhang, Rui Xie, Xiaojian Ma, Tao Yuan, Xinxiao Wu, Songchun Zhu, Qing Li",
      "workshop": ""
    },
    {
      "number": "E08",
      "title": "Multi-Object Sketch Animation by Scene Decomposition and Motion Planning",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "中国人民大学",
      "author": "Jingyu Liu, Zijie Xin, Yuhan Fu, Ruixiang Zhao, Bangxiang Lan, Xirong Li",
      "workshop": ""
    },
    {
      "number": "E09",
      "title": "CogCM: Cognition-Inspired Contextual Modeling for Audio-Visual Speech Enhancement",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "中科院计算技术研究所",
      "author": "Feixiang Wang, Shuang Yang, Shiguang Shan, Xilin Chen",
      "workshop": ""
    },
    {
      "number": "E10",
      "title": "GeneVAR: Causal MeanFlow for Autoregressive Gene-to-WSI Tile Synthesis",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "电子科技大学",
      "author": "Jianwei Zhao, Xin Li, Fan Yang, Qiang Di, Ao Luo, Zhicheng Jiao, Hong Cheng",
      "workshop": ""
    },
    {
      "number": "E11",
      "title": "Streaming Diffusion Model for Fast Infrared and Visible Video Fusion",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "大连理工大学",
      "author": "Jinyuan Liu, Ludan Sun, Tengyu Ma, Chunyan Yang, Zhiying Jiang, Long Ma, Risheng Liu, Xin Fan",
      "workshop": ""
    },
    {
      "number": "E12",
      "title": "TextOVSR: Text-Guided Real-World Opera Video Super-Resolution",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "武汉科技大学",
      "author": "Hua Chang, Xin Xu, Wei Liu, Jiayi Wu, Kui Jiang, Fei Ma, Qi Tian",
      "workshop": ""
    },
    {
      "number": "E13",
      "title": "Diving into Epipolar Transformers for Light Field Super-Resolution and Disparity Estimation",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "国防科技大学",
      "author": "Zhengyu Liang, Yingqian Wang, Longguang Wang, Jungang Yang, Yulan Guo, Li Liu, Shilin Zhou, Wei An",
      "workshop": ""
    },
    {
      "number": "E14",
      "title": "Dual Graph Regularized Deep Unfolding Network for Guided Depth Map Super-resolution",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "香港城市大学",
      "author": "Zhiwei Zhong, Peilin Chen, Qiangqiang Shen, Bo Li, Shiqi Wang",
      "workshop": ""
    },
    {
      "number": "E15",
      "title": "Bridging Fidelity-Reality with Controllable One-Step Diffusion for Image Super-Resolution",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京理工大学",
      "author": "Hao Chen, Junyang Chen, Jinshan Pan, Jiangxin Dong",
      "workshop": ""
    },
    {
      "number": "E16",
      "title": "DELTA: Deep Low-Rank Tensor Representation for Multi-Dimensional Data Recovery",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "西南财经大学",
      "author": "Guowei Yang, Liqiao Yang, Taixiang Jiang, Guisong Liu, Michael K. Ng",
      "workshop": ""
    },
    {
      "number": "E17",
      "title": "SigFusion: Unified Signal-Level Self-Supervised Learning Paradigm for Image Fusion",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "大连民族大学",
      "author": "Zeyu Wang, Jiawei Feng, Jiayu Wang, Pengjie Wang, Haiyu Song",
      "workshop": ""
    },
    {
      "number": "E18",
      "title": "All-in-One Slider for Attribute Manipulation in Diffusion Models",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "北京交通大学",
      "author": "Weixin Ye, Hongguang Zhu, Wei Wang, Yahui Liu, Mengyu Wang, Xuecheng Nie",
      "workshop": ""
    },
    {
      "number": "E19",
      "title": "Benchmarking Endoscopic Surgical Image Restoration and Beyond",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "香港中文大学",
      "author": "Jialun Pei, Diandian Guo, Donghui Yang, Zhixi Li, Yuxin Feng, Long Ma, Bo Du, Pingan Wang",
      "workshop": ""
    },
    {
      "number": "E20",
      "title": "LiDARCrafter: Dynamic 4D World Modeling from LiDAR Sequences",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "新加坡国立大学， 中国科学院沈阳自动化研究所",
      "author": "Ao Liang, Dongyue Lu, Youquan Liu, Yu Yang, Linfeng Li, Lingdong Kong, Huaici Zhao, Wei Tsang Ooi",
      "workshop": ""
    },
    {
      "number": "E21",
      "title": "ChangeBridge: Spatiotemporal Image Generation with Multimodal Controls for Remote Sensing",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "武汉大学",
      "author": "Zhenghui Zhao, Chen Wu, Xiangyong Cao, Di Wang, Hongruixuan Chen, Datao Tang, Bo Du, Liangpei Zhang, Zhuo Zheng",
      "workshop": ""
    },
    {
      "number": "E22",
      "title": "EasyTune: Efficient Step-Aware Fine-Tuning for Diffusion-Based Motion Generation",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "东南大学",
      "author": "Xiaofeng Tan, Wanjiang Weng, Haodong Lei, Hongsong Wang",
      "workshop": ""
    },
    {
      "number": "E23",
      "title": "Stability-Driven Motion Generation for Object-Guided Human-Human Co-Manipulation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "天津大学",
      "author": "Jiahao Xu, Xiaohan Yuan, Xingchen Wu, Chongyang Xu, Kun Li, Buzhen Huang",
      "workshop": ""
    },
    {
      "number": "E24",
      "title": "MODEM: A Morton-Order Degradation Estimation Mechanism for Adverse Weather Image Recovery",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "天津大学",
      "author": "Hainuo Wang, Qiming Hu, Xiaojie Guo",
      "workshop": ""
    },
    {
      "number": "E25",
      "title": "Rectifying Latent Space for Generative Single-Image Reflection Removal",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "天津大学",
      "author": "Mingjia Li, Jin Hu, Hainuo Wang, Qiming Hu, Jiarui Wang, Xiaojie Guo",
      "workshop": ""
    },
    {
      "number": "E26",
      "title": "Learning from History: Task-agnostic Model Contrastive Learning for Image Restoration",
      "qikan": "International Journal of Computer Vision (IJCV) 2026",
      "unit": "哈尔滨工业大学",
      "author": "Gang Wu, Junjun Jiang, Kui Jiang, Xianming Liu, Wangmeng Zuo",
      "workshop": ""
    },
    {
      "number": "E27",
      "title": "Text-Aware Real-World Image Super-Resolution via Diffusion Model with Joint Segmentation Decoders",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "天津大学",
      "author": "Qiming Hu, Linlong Fan, Yiyan Luo, Yuhang Yu, Xiaojie Guo, Qingnan Fan",
      "workshop": ""
    },
    {
      "number": "E28",
      "title": "HiFi-Inpaint: Towards High-Fidelity Reference-Based Inpainting for Generating Detail-Preserving Human-Product Images",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "香港中文大学，字节跳动",
      "author": "Yichen Liu, Donghao Zhou, Jie Wang, Xin Gao, Guisheng Liu, Jiatong Li, Quanwei Zhang, Qiang Liu, Lanqing Guo, Shilei Wen, Weiqiang Wang, Pingan Wang",
      "workshop": ""
    },
    {
      "number": "E29",
      "title": "NeoVerse: Enhancing 4D World Model with in-the-wild Monocular Videos",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中科院自动化所",
      "author": "Yuxue Yang, Lve Fan, Ziqi Shi, Junran Peng, Feng Wang, Zhaoxiang Zhang",
      "workshop": ""
    },
    {
      "number": "E30",
      "title": "UniFuse: A Unified All-in-One Framework for Multi-Modal Medical Image  Fusion Under Diverse Degradations and Misalignments",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "昆明理工大学",
      "author": "Dayong Su, Yafei Zhang, Huafeng Li, Jinxing Li, Yu Liu",
      "workshop": ""
    },
    {
      "number": "E31",
      "title": "Stochastic Self-Guidance for Training-Free Enhancement of Diffusion Models",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "阿里巴巴集团",
      "author": "Chubin Chen, Jiashu Zhu, Xiaokun Feng, Nisha Huang, Chen Zhu, Meiqi Wu, Fangyuan Mao, Jiahong Wu, Xiangxiang Chu, Xiu Li",
      "workshop": ""
    },
    {
      "number": "E33",
      "title": "MorphAny3D: Unleashing the Power of Structured Latent in 3D Morphing",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京大学",
      "author": "Xiaokun Sun, Zeyu Cai, Hao Tang, Ying Tai, Jian Yang, Zhenyu Zhang",
      "workshop": ""
    },
    {
      "number": "E34",
      "title": "NEC-Diff: Noise-Robust Event–RAW Complementary Diffusion for Seeing Motion in Extreme Darkness",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "华中科技大学",
      "author": "Haoyue Liu, Jinghan Xu, Luxin Feng, Hanyu Zhou, Haozhi Zhao, Yi Chang, Luxin Yan",
      "workshop": ""
    },
    {
      "number": "E35",
      "title": "Learning An Adaptive Sparse Transformer for Efficient Image Restoration",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2025",
      "unit": "南开大学",
      "author": "Shihao Zhou, Jinshan Pan, Jufeng Yang",
      "workshop": ""
    },
    {
      "number": "E36",
      "title": "ImageSentinel: Protecting Visual Datasets from Unauthorized Retrieval-Augmented Image Generation",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "香港浸会大学",
      "author": "Ziyuan Luo, Yangyi Zhao, Ka Chun Cheung, Simon See, Renjie Wan",
      "workshop": ""
    },
    {
      "number": "E37",
      "title": "Representation Entanglement for Generation: Training Diffusion Transformers Is Much Easier Than You Think",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "南开大学、南开国际先进研究院、极豪科技、哈佛大学、中国科学院大学",
      "author": "Ge Wu, Shen Zhang, Ruijing Shi, Shanghua Gao, Zhenyuan Chen, Lei Wang, Zhaowei Chen, Hongcheng Gao, Yao Tang, Jian Yang, Mingming Cheng, Xiang Li",
      "workshop": ""
    },
    {
      "number": "E38",
      "title": "Neural Video Compression with Reference Hierarchy",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "中国科学技术大学",
      "author": "Chuanbo Tang, Zhuoyuan Li, Li Li, Dong Liu, Feng Wu",
      "workshop": ""
    },
    {
      "number": "E39",
      "title": "Learned Image Compression with Hierarchical Progressive Context Modeling",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "中国科学技术大学",
      "author": "Yuqi Li, Haotian Zhang, Li Li, Dong Liu",
      "workshop": ""
    },
    {
      "number": "E40",
      "title": "Unsupervised Hyperspectral Image Super-Resolution via Self-Supervised Modality Decoupling",
      "qikan": "International Journal of Computer Vision (IJCV) 2026",
      "unit": "西北工业大学",
      "author": "Songcheng Du, Yang Zou, Zixu Wang, Xingyuan Li, Ying Li, Changjing Shang, Qiang Shen",
      "workshop": ""
    },
    {
      "number": "E41",
      "title": "BurstDeflicker: A Benchmark Dataset for Flicker Removal in Dynamic Scenes",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "南开大学",
      "author": "Lishen Qu, Zhihao Liu, Shihao Zhou, Yaqi Luo, Jie Liang, Hui Ceng, Lei Zhang, Jufeng Yang",
      "workshop": ""
    },
    {
      "number": "E42",
      "title": "WaDi: Weight Direction-aware Distillation for One-step Image Synthesis",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南开大学",
      "author": "Lei Wang, Yang Cheng, Senmao Li, Ge Wu, Yaxing Wang, Jian Yang",
      "workshop": ""
    },
    {
      "number": "E43",
      "title": "The Devil is in Attention Sharing: Improving Complex Non-rigid Image Editing Faithfulness via Attention Synergy",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "电子科技大学",
      "author": "Zhuo Chen, Fanyue Wei, Runze Xu, Jingjing Li, Lixin Duan, Angela Yao, Wen Li",
      "workshop": ""
    },
    {
      "number": "E44",
      "title": "PerTouch: VLM-Driven Agent for Personalized and Semantic Image Retouching",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "南开大学",
      "author": "Zewei Chang, Zhengpeng Duan, Jianxing Zhang, Chunle Guo, Siyu Liu, Hyungju Chun, Hyunhee Park, Zikun Liu, Zhongyi Li",
      "workshop": ""
    },
    {
      "number": "E45",
      "title": "BeautyGRPO: Aesthetic Alignment for Face Retouching via Dynamic Path Guidance and Fine-Grained Preference Modeling",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中山大学",
      "author": "Jiachen Yang, Xianhui Lin, Yi Dong, Zebiao Zheng, Xing Liu, Hong Gu, Yanmei Fang",
      "workshop": ""
    },
    {
      "number": "E46",
      "title": "Beyond Visual Reconstruction Quality: Object Perception-aware 3D Gaussian Splatting for Autonomous Driving",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "阿尔伯塔大学",
      "author": "Renzhi Wang, Yuxiang Fu, Wuqi Wang, Haigen Min, Wei Feng, Lei Ma, Qing Guo",
      "workshop": ""
    },
    {
      "number": "E47",
      "title": "VDFE: Difference-Aware 3D Scene Editing with Non-Intrusive Video Diffusion Priors for Multi-View Consistency and Efficiency",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "西安电子科技大学",
      "author": "Chao Zhang, Fang Liu, Shuo Li, Yang Liu, Jiahao Wang, Xinyan Huang, Lingling Li, Puhua Chen, Xu Liu, Wenping Ma, Siqi Wei",
      "workshop": ""
    },
    {
      "number": "E48",
      "title": "Texvent: Asynchronous Event Data Simulation via Text Prompt",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "香港浸会大学",
      "author": "Ruofei Wang, Peiqi Duan, Ka Chun Cheung, Simon See, Boxin Shi, Renjie Wan",
      "workshop": ""
    },
    {
      "number": "E49",
      "title": "Multi-Modal Image Fusion via Intervention-Stable Feature Learning",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "云南大学；南阳师范学院",
      "author": "Xue Wang, Zheng Guan, Wenhua Qian, Chengchao Wang, Runzhuo Ma",
      "workshop": ""
    },
    {
      "number": "E50",
      "title": "Uniform Discrete Diffusion with Metric Path for Video Generation",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "自动化所，智源研究院",
      "author": "Haoge Deng, Ting Pan, Fan Zhang, Yang Liu, Zhuoyan Luo, Yufeng Cui, Wenxuan Wang, Chunhua Shen, Shiguang Shan, Zhaoxiang Zhang, Xinlong Wang",
      "workshop": ""
    },
    {
      "number": "E51",
      "title": "SMRABooth: Subject and Motion Representation Alignment for Customized Video Generation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京邮电大学",
      "author": "Xuancheng Xu, Yaning Li, Sisi You, Bingkun Bao",
      "workshop": ""
    },
    {
      "number": "E53",
      "title": "StereoWorld: Geometry-Aware Monocular-to-Stereo Video Generation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "北京交通大学",
      "author": "Ke Xing, Longfei Li, Yuyang Yin, Hanwen Liang, Guixun Luo, Chen Fang, Jue Wang, Konstantinos N. Plataniotis, Xiaojie Jin, Yao Zhao, Yunchao Wei",
      "workshop": ""
    },
    {
      "number": "E54",
      "title": "Circular-DPO: Aligning Multi-Stage 3D Generative Models via Preference Feedback Loop",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "浙江大学",
      "author": "Zejian Li, Jiarui Ma, Han Xu, Weiting Zheng, Yangrui Zhu, Chenye Meng, Pei Chen, Ling Yang, Zhiyuan Yang, Changyuan Yang, Guang Yang, Immanuel Koh, Lingyun Sun",
      "workshop": ""
    },
    {
      "number": "E55",
      "title": "Group Editing: Edit Multiple Images in One Go",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "香港科技大学",
      "author": "Yue Ma, Xinyu Wang, Qianli Ma, Qinghe Wang, Mingzhe Zheng, Xiangpeng Yang, Hao Li, Chongbo Zhao, Jixuan Ying, Harry Yang, Hongyu Liu, Qifeng Chen",
      "workshop": ""
    },
    {
      "number": "E56",
      "title": "Semantic Context Matters: Improving Conditioning for Autoregressive Models",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "阿里巴巴",
      "author": "Dongyang Jin, Ryan Xu, Jianhao Ceng, Yancheng Bai, Lei Sun, Xiangxiang Chu",
      "workshop": ""
    },
    {
      "number": "E58",
      "title": "DeAltHDR: Learning HDR Video Reconstruction from Degraded Alternating Exposure Sequences",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "哈尔滨工业大学",
      "author": "Shuohao Zhang, Zhilu Zhang, Rongjian Xu, Xiaohe Wu, Wangmeng Zuo",
      "workshop": ""
    },
    {
      "number": "E59",
      "title": "UPP: Unified Point-Level Prompting for Robust Point Cloud Analysis",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "北京大学",
      "author": "Zixiang Ai, Zhenyu Cui, Yuxin Peng, Jiahuan Zhou",
      "workshop": ""
    },
    {
      "number": "E60",
      "title": "AirSim360: A Panoramic Simulation Platform within Drone View",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "Insta360",
      "author": "Xian Ge, Yuling Pan, Yuhang Zhang, Xiang Li, Weijun Zhang, Dizhe Zhang, Zhaoliang Wan, Xin Lin, Xiangkai Zhang, Juntao Liang, Jason Li, Wenjie Jiang, Bo Du, Ming-Hsuan Yang, Lu Qi",
      "workshop": ""
    },
    {
      "number": "E61",
      "title": "GenieDrive: Towards Physics-Aware Driving World Model with 4D Occupancy Guided Video Generation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "香港大学",
      "author": "Zhenya Yang, Zhe Liu, Yuxiang Lu, Liping Hou, Chenxuan Mou, Siyi Peng, Bailan Feng, Xiang Bai, Hengshuang Zhao",
      "workshop": ""
    },
    {
      "number": "E62",
      "title": "LaS-Comp: Zero-shot 3D Completion with Latent–Spatial Consistency",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "新加坡国立大学",
      "author": "Weilong Yan, Haipeng Li, Hao Xu, Nianjin Ye, Yihao Ai, Shuaicheng Liu, Jingyu Hu",
      "workshop": ""
    },
    {
      "number": "E63",
      "title": "Stand-in: A lightweight and plug-and-play identity control for video generation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南开大学",
      "author": "Bowen Xue, Zheng-Peng Duan, Qixin Yan, Wenjing Wang, Hao Liu, Chun-Le Guo, Chongyi Li, Chen Li, Jing Lyu",
      "workshop": ""
    },
    {
      "number": "E64",
      "title": "Robust Noise Modeling for Spike Camera via Time-Interval Quantification and Spike-DSLR Multimodal Dataset in Low-Light Imaging",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "哈尔滨工程大学",
      "author": "Yue Cao, Sizhao Li, Liguo Zhang",
      "workshop": ""
    },
    {
      "number": "E65",
      "title": "LayerInbetween: Occlusion-Aware Stroke Correspondence and Inbetweening with Automatic Layering",
      "qikan": "ACM SIGGRAPH (SIGGRAPH) 2026",
      "unit": "香港科技大学（广州）",
      "author": "Haoran Mo, Zhongyue Guan, Yixin Hu, Zeyu Wang",
      "workshop": ""
    },
    {
      "number": "F01",
      "title": "ThinkOmni: Lifting Textual Reasoning to Omni-modal Scenarios via Guidance Decoding",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "华中科技大学",
      "author": "Yiran Guan, Sifan Tu, Dingkang Liang, Linghao Zhu, Jianzhong Ju, Zhenbo Luo, Jian Luan, Yuliang Liu, Xiang Bai",
      "workshop": ""
    },
    {
      "number": "F02",
      "title": "Shuffle-R1: Efficient RL Framework for Multimodal Large Language Models via Data-centric Dynamic Shuffle",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "华中科技大学",
      "author": "Linghao Zhu, Yiran Guan, Dingkang Liang, Jianzhong Ju, Zhenbo Luo, Bin Qin, Jian Luan, Yuliang Liu, Xiang Bai",
      "workshop": ""
    },
    {
      "number": "F03",
      "title": "TagaVLM: Topology-Aware Global Action Reasoning for Vision-Language Navigation",
      "qikan": "IEEE International Conference on Robotics and Automation (ICRA) 2026",
      "unit": "北京工业大学",
      "author": "Jiaxing Liu, Zexi Zhang, Xiaoyan Li, Boyue Wang, Yongli Hu, Baocai Yin",
      "workshop": ""
    },
    {
      "number": "F04",
      "title": "See What I Mean: Aligning Vision and Language Representations for Video Fine-grained Object Understanding",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南开大学",
      "author": "Boyuan Sun, Bowen Yin, Yuanming Li, Xihan Wei, Qibin Hou",
      "workshop": ""
    },
    {
      "number": "F05",
      "title": "Player-Centric Multimodal Prompt Generation for Large Language Model Based Identity-Aware Basketball Video Captioning",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "北京工业大学",
      "author": "Zeyu Xi, Haoying Sun, Yaofei Wu, Junchi Yan, Haoran Zhang, Lifang Wu, Liang Wang, Zhangwen Chen",
      "workshop": ""
    },
    {
      "number": "F06",
      "title": "Discriminative Perception via Anchored Description for Reasoning Segmentation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "西北工业大学",
      "author": "Tao Yang, Qing Zhou, Yanliang Li, Qi Wang",
      "workshop": ""
    },
    {
      "number": "F07",
      "title": "Look Twice Before You Answer: Memory-Space Visual Retracing for Hallucination Mitigation in MLLM",
      "qikan": "International Conference on Machine Learning (ICML) 2025",
      "unit": "香港科技大学（广州）",
      "author": "Xin Zou, Yizhou Wang, Yibo Yan, Yuanhuiyi Lv, Kening Zheng, Sirui Huang, Junkai Chen, Peijie Jiang, Jia Liu, Chang Tang, Xuming Hu",
      "workshop": ""
    },
    {
      "number": "F08",
      "title": "OwlCap: Harmonizing Motion-Detail for Video Captioning via HMD-270K and Caption Set Equivalence Reward",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "华中科技大学",
      "author": "Chunlin Zhong, Qiuxia Hou, Zhangjun Zhou, Yanhao Zhang, Shuang Hao, Haonan Lu, He Tang, Xiang Bai",
      "workshop": ""
    },
    {
      "number": "F09",
      "title": "Iterative Tool Usage Exploration for Multimodal Agents via Step-wise Preference Tuning",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "北京理工大学",
      "author": "Pengxiang Li, Zhi Gao, Bofei Zhang, Yapeng Mi, Xiaojian Ma, Chenrui Shi, Tao Yuan, Yuwei Wu, Yunde Jia, Songchun Zhu, Qing Li",
      "workshop": ""
    },
    {
      "number": "F11",
      "title": "LLaDA-V: Large Language Diffusion Models with Visual Instruction Tuning",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中国人民大学",
      "author": "Zebin You, Shen Nie, Xiaolu Zhang, Jun Zhou, Zhiwu Lu, Jirong Wen, Chongxuan Li",
      "workshop": ""
    },
    {
      "number": "F12",
      "title": "BTL-UI: Blink-Think-Link Reasoning Model for GUI Agent",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "北京小米移动软件有限公司",
      "author": "Shaojie Zhang, Ruoceng Zhang, Pei Fu, Shaokang Wang, Jiahui Yang, Xin Du, Shiqi Cui, Bin Qin, Ying Huang, Zhenbo Luo, Jian Luan",
      "workshop": ""
    },
    {
      "number": "F13",
      "title": "SurgCoT: Advancing Spatiotemporal Reasoning in Surgical Videos through a Chain-of-Thought Benchmark",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "深圳大学",
      "author": "Gui Wang, Yongsong Zhou, Kaijun Deng, Wooi Ping Cheah, Rong Qu",
      "workshop": ""
    },
    {
      "number": "F14",
      "title": "Modality Alignment across Trees on Heterogeneous Hyperbolic Manifolds",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "北京理工大学",
      "author": "Wei Wu, Xiaomeng Fan, Yuwei Wu, Zhi Gao, Pengxiang Li, Yunde Jia, Mehrtash_Harandi",
      "workshop": ""
    },
    {
      "number": "F15",
      "title": "Text-Guided Channel Perturbation and Pretrained Knowledge Integration for Unified Multi-Modality Image Fusion",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "佛山大学",
      "author": "Xilai Li, Xiaosong Li, Weijun Jiang",
      "workshop": ""
    },
    {
      "number": "F16",
      "title": "Agent Trading Arena: A Study on Numerical Understanding in LLM-Based Agents",
      "qikan": "Conference on Empirical Methods in Natural Language Processing (EMNLP) 2025",
      "unit": "武汉理工大学",
      "author": "Tianmi Ma, Jiawei Du, Wenxin Huang, Wenjie Wang, Liang Xie, Xian Zhong, Tianyi Zhou",
      "workshop": ""
    },
    {
      "number": "F17",
      "title": "From Natural Alignment to Conditional Controllability in Multimodal Dialogue",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "清华大学",
      "author": "Zeyu Jin, Songtao Zhou, Haoyu Wang, Minghao Tian, Kaifeng Yuan, Zhuo Chen, Xiaoyu Qin, Jia Jia",
      "workshop": ""
    },
    {
      "number": "F18",
      "title": "Imbalanced View Contribution Evaluation and Refinement for Deep Incomplete Multi-View Clustering",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "国防科技大学",
      "author": "Taichun Zhou, Zhibin Dong, Hao Tan, Siwei Wang, Xinwang Liu, En Zhu, Di Hu, Tianrui Liu, Chuankun Li, Kunlun He",
      "workshop": ""
    },
    {
      "number": "F19",
      "title": "MMBench-GUI: A Unified Hierarchical Evaluation Framework for Multi-Platform GUI Agents",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "上海交通大学",
      "author": "Xuehui Wang, Zhenyu Wu, Jingjing Xie, Zichen Ding, Bowen Yang, Zehao Li, Zhaoyang Liu, Qingyun Li, Xuan Dong, Zhe Chen, Weiyun Wang, Xiangyu Zhao, Jixuan Chen, Haodong Duan, Tianbao Xie, Chenyu Yang, Shiqian Su, Yue Yu, Yanting Zhang, Xiangyu Yue, Weijie Su, Xizhou Zhu, Wei Shen, Jifeng Dai, Wenhai Wang",
      "workshop": ""
    },
    
    {
      "number": "F21",
      "title": "ADARULE: LLM-Driven Natural Language to LTL Conversion via Pattern-Adaptive Rule Induction",
      "qikan": "International Conference on Software Engineering (ICSE) 2026",
      "unit": "华东师范大学",
      "author": "Jiayi Hu, Jingling Sun, Chong Wang, Yihao Huang, Jingcao Feng, Yilongfei Xu, Yong Li, Kailong Wang, Weikai Mou, Jingsong Dong, Geguang Pu",
      "workshop": ""
    },
    {
      "number": "F22",
      "title": "AutoDrive-P3: Unified Chain of Perception-Prediction-Planning Thought via Reinforcement Fine-Tuning",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "北京大学",
      "author": "Yuqi Ye, Zijian Zhang, Junhong Lin, Shangkun Sun, Changhao Peng, Wei Gao",
      "workshop": ""
    },
    {
      "number": "F23",
      "title": "PRISM: Festina Lente Proactivity—Risk-Sensitive， Uncertainty-Aware Deliberation for Proactive Agents",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "上海工程技术大学",
      "author": "Yuxuan Fu, Xiaoyu Tan, Teqi Hao, Chen Zhan, Xihe Qiu",
      "workshop": ""
    },
    {
      "number": "F24",
      "title": "OmniVTG: A Large-Scale Dataset and Training Paradigm for Open-World Video Temporal Grounding",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "北京大学",
      "author": "Minghang Zheng, Zihao Yin, Yi Yang, Yuxin Peng, Yang Liu",
      "workshop": ""
    },
    {
      "number": "F25",
      "title": "Inconsistency-aware Multimodal Schrödinger Bridge for Deepfake Localization",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "华侨大学",
      "author": "Jiayu Xiong, Jing Wang, Qi Zhang, Wanlong Wang, Jun Xue",
      "workshop": ""
    },
    {
      "number": "F26",
      "title": "Adversarial attacks against closed-source mllms via feature optimal alignment",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "新加坡南洋理工大学",
      "author": "Xiaojun Jia, Sensen Gao, Simeng Qin, Tianyu Pang, Chao Du, Yihao Huang, Xinfeng Li, Bo Li, Yang Liu",
      "workshop": ""
    },
    {
      "number": "F28",
      "title": "Uncertainty-Aware Medical Diagnostic Phrase Identification and Grounding",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2025",
      "unit": "新加坡国立大学",
      "author": "Ke Zou, Yang Bai, Bo Liu, Yidi Chen, Zhihao Chen, Yang Zhou, Xuedong Yuan, Meng Wang, Xiaojing Shen, Xiaochun Cao, Yih Chung Tham, Huazhu Fu",
      "workshop": ""
    },
    {
      "number": "F30",
      "title": "CHIPS: Efficient CLIP Adaptation via Curvature-aware Hybrid Influence-based Data Selection",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "华东师范大学， MBZUAI",
      "author": "Xinlin Zhuang, Yichen Li, Xiwei Liu, Haolin Yang, Yifan Lu, Ziyun Zou, Yulong Li, Huifa Li, Dongliang Chen, Qinglei Wang, Weiyang Liu, Ying Qian, Jiangming Shi, Imran Razzak",
      "workshop": ""
    },
    {
      "number": "F31",
      "title": "Multi-Paradigm Collaborative Adversarial Attack Against Multimodal Large Language Models",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "江南大学",
      "author": "Yuanbo Li, Tianyang Xu, Cong Hu, Tao Zhou, Xiaojun Wu, Josef Kittler",
      "workshop": ""
    },
    {
      "number": "F32",
      "title": "EgoExoBench: A Benchmark for First- and Third-person View Video Understanding in MLLMs",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "南京大学",
      "author": "Yuping He, Yifei Huang, Guo Chen, Baoqi Pei, Jilan Xu, Tong Lu, Jiangmiao Pang",
      "workshop": ""
    },
    {
      "number": "F33",
      "title": "Multimodal Spiking Neural Network for Image-Text Retrieval",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "武汉理工大学",
      "author": "Xintao Zong, Xian Zhong, Wenxuan Liu, Jianhao Ding, Zhaofei Yu, Tiejun Huang",
      "workshop": ""
    },
    {
      "number": "F34",
      "title": "Agentic Learner with Grow-and-Refine Multimodal Semantic Memory",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京理工大学/百度",
      "author": "Weihao Bao, Shan Zhang, Yanpeng Sun, Jingjing Wu, Qunyi Xie, Xiao Tan, Kunbin Chen, Wei He, Xiaofan Li, Na Zhao, Jingdong Wang, Zechao Li",
      "workshop": ""
    },
    {
      "number": "F35",
      "title": "RegionRAG: Region-level Retrieval-Augmented Generation for Visual Document Understandinghttps://arxiv.org/abs/2510.27261",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "中国科学技术大学",
      "author": "Yinglu Li, Zhiying Lu, Zhihang Liu, Yiwei Sun, Chuanbin Liu, Hongtao Xie",
      "workshop": ""
    },
    {
      "number": "F36",
      "title": "CodePercept: Code-Grounded Visual STEM Perception for MLLMs",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "上海交通大学，Qwen",
      "author": "Tongkun Guan, Zhibo Yang, Jianqiang Wan, Mingkun Yang, Peng Wang, Wei Shen, Junyang Lin, Xiaokang Yang",
      "workshop": ""
    },
    {
      "number": "F37",
      "title": "PromptHub: Enhancing Multi-Prompt Visual In-Context Learning with Locality-Aware Fusion， Concentration and Alignment",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "清华大学",
      "author": "Tianci Luo, Jinpeng Wang, Shiyu Qin, Niu Lian, Yan Feng, Bin Chen, Chun Yuan, Shutao Xia",
      "workshop": ""
    },
    {
      "number": "F38",
      "title": "CalliReader : Contextualizing Chinese Calligraphy via an Embedding-Aligned Vision-Language Model",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "北京大学王选计算机研究所",
      "author": "Yuxuan Luo, Jiaqi Tang, Chenyi Huang, Feiyang Hao",
      "workshop": ""
    },
    {
      "number": "F39",
      "title": "OAD-Promoter: Enhancing Zero-Shot VQA Using Large Language Models with Object Attribute Description",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "澳门科技大学",
      "author": "Quanxing Xu, Ling Zhou, Feifei Zhang, Rubing Huang, Jinyu Tian",
      "workshop": ""
    },
    {
      "number": "F40",
      "title": "Think， Then Verify: A Hypothesis-Verification Multi-Agent Framework for Long Video Understanding",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "浙江工业大学",
      "author": "Zheng Wang, Haoran Chen, Haoxuan Qin, Zhipeng Wei, Tianwen Qian, Cong Bai",
      "workshop": ""
    },
    {
      "number": "F41",
      "title": "ORSATR-X: A Foundation Model based on Differential-and-Excitation Networks for Optical Remote Sensing Object Recognition",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "国防科技大学",
      "author": "Canyu Mo, Yongxiang Liu, Jiehua Zhang, Zilong Yu, Zhen Liu, Tianpeng Liu, Li Liu",
      "workshop": ""
    },
    {
      "number": "F42",
      "title": "VIP: Vision Instructed Pre-training for Robotic Manipulation",
      "qikan": "International Conference on Machine Learning (ICML) 2025",
      "unit": "香港大学",
      "author": "Zhuoling Li, Liangliang Ren, Jinrong Yang, Yong Zhao, Xiaoyang Wu, Zhenhua Xu, Xiang Bai, Hengshuang Zhao",
      "workshop": ""
    },
    {
      "number": "F43",
      "title": "Chain-of-Thought Guided Multi-Modal Object Re-Identification",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "安徽大学",
      "author": "Ya Gao, Shihao Li, Zhaojun Liu, Aihua Zheng, Chenglong Li, Jin Tang",
      "workshop": ""
    },
    {
      "number": "F44",
      "title": "Cross-Modal Alignment via Variational Copula Modelling",
      "qikan": "International Conference on Machine Learning (ICML) 2025",
      "unit": "香港大学",
      "author": "Feng Wu, Tsai Hor Chan, Fuying Wang, Guosheng Yin, Lequan Yu",
      "workshop": ""
    },
    {
      "number": "F45",
      "title": "Test-Time Perturbation Learning  with Delayed Feedback for Vision-Language-Action Models",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中国科学院软件研究所",
      "author": "Zehua Zang, Xi Wang, Fuchun Sun, Xiao Xu, Lixiang Liu, Jiangmeng Li, Jiahuan Zhou",
      "workshop": ""
    },
    {
      "number": "F46",
      "title": "CLiViS: Unleashing Cognitive Map through Linguistic-Visual Synergy for Embodied Visual Reasoning",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "华东师范大学",
      "author": "Kailing Li, Qiao Xu, Tianwen Qian, Yuqian Fu, Yang Jiao, Xiaoling Wang",
      "workshop": ""
    },
    {
      "number": "F47",
      "title": "InfoSAM: Fine-Tuning the Segment Anything Model from An Information-Theoretic Perspective",
      "qikan": "International Conference on Machine Learning (ICML) 2025",
      "unit": "西安交通大学",
      "author": "Yuanhong Zhang, Muyao Yuan, Weizhan Zhang, Tieliang Gong, Wen Wen, Jiangyong Ying, Weijie Shi",
      "workshop": ""
    },
    {
      "number": "F48",
      "title": "V-Attack: Targeting Disentangled Value Features for Controllable Adversarial Attacks on LVLMs",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中科院计算所",
      "author": "Sen Nie, Jie Zhang, Jianxin Yan, Shiguang Shan, Xilin Chen",
      "workshop": ""
    },
    {
      "number": "F50",
      "title": "MaskPro: Linear-Space Probabilistic Learning for Strict (N:M)-Sparsity on LLMs",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "中山大学",
      "author": "Yan Sun, Qixin Zhang, Zhiyuan Yu, Xikun Zhang, Li Shen, Dacheng Tao",
      "workshop": ""
    },
    {
      "number": "F51",
      "title": "Sample-Cohesive Pose-Aware Contrastive Facial Representation Learning",
      "qikan": "International Journal of Computer Vision (IJCV) 2025",
      "unit": "中国地质大学（武汉）",
      "author": "Yuanyuan Liu, Shaoze Feng, Shuyang Liu, Yibingdeng Zhan",
      "workshop": ""
    },
    {
      "number": "F52",
      "title": "Beyond Multiple Choice: Verifiable OpenQA for Robust Vision-Language RFT",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中科院自动化所/北京智源研究院",
      "author": "Yesheng Liu, Hao Li, Haiyu Xu, Baoqi Pei, Jiahao Wang, Mingxuan Zhao, Jingshu Zheng, Zheqi He, Jinge Yao, Bowen Qin, Xi Yang, Jiajun Zhang",
      "workshop": ""
    },
    {
      "number": "F53",
      "title": "Chatvla-2: Vision-language-action model with open-world reasoning",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "Current Robotics",
      "author": "Zhongyi Zhou, Yichen Zhu, Xiaoyu Liu, Zhibin Tang, Junjie Wen, Yaxin Peng, Chaomin Shen, Yi Xu",
      "workshop": ""
    },
    {
      "number": "F54",
      "title": "Tackling Alignment Ambiguity in Person Retrieval through Conversational Attribute Mining",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "电子科技大学",
      "author": "Hao Zou, Runqing Zhang, Jin Ding, Xue Zhou, Jianxiao Zou, Mingzhu Cai",
      "workshop": ""
    },
    {
      "number": "F55",
      "title": "VT-FSL: Bridging Vision and Text with LLMs for Few-Shot Learning",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "山东大学、深圳河套学院",
      "author": "Wenhao Li, Qiangchang Wang, Xianjing Meng, Zhibin Wu, Yilong Yin",
      "workshop": ""
    },
    {
      "number": "G01",
      "title": "Knowledge Graph Enhanced Generative Multi-modal Models for Class-Incremental Learning",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "南开大学",
      "author": "Xusheng Cao, Haori Lu, Linlan Huang, Fei Yang, Xialei Liu, Mingming Cheng",
      "workshop": ""
    },
    {
      "number": "G02",
      "title": "SpikeVideoFormer: An Efficient Spike-Driven Video Transformer with Hamming Attention and O(T) Complexity",
      "qikan": "International Conference on Machine Learning (ICML) 2025",
      "unit": "中国科学院深圳先进技术研究院",
      "author": "Shihao Zou, Qingfeng Li, Wei Ji, Jingjing Li, Yongkui Yang, Guoqi Li, Chao Dong",
      "workshop": ""
    },
    {
      "number": "G03",
      "title": "Taming Cascaded Mixture-of-Experts for Modality-Missing Multi-Modal Salient Object Detection",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "南京林业大学",
      "author": "Kunpeng Wang, Feifan Sun, Keke Chen",
      "workshop": ""
    },
    {
      "number": "G04",
      "title": "Towards Visual Grounding: A Survey",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2025",
      "unit": "鹏城国家实验室",
      "author": "Linhui Xiao, Xiaoshan Yang, Xiangyuan Lan, Yaowei Wang, Changsheng Xu",
      "workshop": ""
    },
    {
      "number": "G05",
      "title": "PlanaReLoc: Camera Relocalization in 3D Planar Primitives via Region-based Structure Matching",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中国科学院大学；中国科学院自动化研究所",
      "author": "Hanqiao Ye, Yuzhou Liu, Yangdong Liu, Shuhan Shen",
      "workshop": ""
    },
    {
      "number": "G07",
      "title": "Domain-Aware Suppression and Aggregation for Federated DG ReID",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "武汉科技大学",
      "author": "Zhixi Yu, Wei Liu, Wenke Huang, Bin Yang, Qian Bie, Guancheng Wan, Xin Xu",
      "workshop": ""
    },
    {
      "number": "G08",
      "title": "Rolling and Denoising: Rethinking Dynamic Modal Fusion for Multi-Modal Object Re-Identification",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "安徽大学",
      "author": "Shihao Li, Huaibo Huang, Aihua Zheng, Jin Tang, Ran He",
      "workshop": ""
    },
    {
      "number": "G09",
      "title": "MVGGT: Multimodal Visual Geometry Grounded Transformer for Multiview 3D Referring Expression Segmentation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "厦门大学、上海创智学院",
      "author": "Changli Wu, Haodong Wang, Jiayi Ji, Yutian Yao, Chunsai Du, Jihua Kang, Yanwei Fu, Liujuan Cao",
      "workshop": ""
    },
    {
      "number": "G10",
      "title": "Synergistic Bleeding Region and Point Detection in Laparoscopic Surgical Videos",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "香港中文大学",
      "author": "Jialun Pei, Zhangjun Zhou, Diandian Guo, Zhixi Li, Jing Qin, Bo Du, Pingan Wang",
      "workshop": ""
    },
    {
      "number": "G11",
      "title": "VLM-Loc: Localization in Point Cloud Maps via Vision-Language Models",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南开大学",
      "author": "Shuhao Kang, Youqi Liao, Peijie Wang, Wenlong Liao, Qilin Zhang, Benjamin Busam, Xieyuanli Chen, Yun Liu",
      "workshop": ""
    },
    {
      "number": "G12",
      "title": "ZigzagPointMamba: Spatial-Semantic Mamba for Point Cloud Understanding",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "新疆大学",
      "author": "Linshuang Diao, Sensen Song, Yurong Qian, Dayong Ren",
      "workshop": ""
    },
    {
      "number": "G13",
      "title": "Revisiting 360 depth estimation with panogabor: A new fusion perspective",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "北京交通大学",
      "author": "Zhijie Shen, Chunyu Lin, Lang Nie, Kang Liao, Weisi Lin, Yao Zhao",
      "workshop": ""
    },
    {
      "number": "G14",
      "title": "SkySense-VITA: Towards Universal In-context Segmentation of Multi-modal Remote Sensing Imagery",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "武汉大学",
      "author": "Kang Wu, Lei Yu, Junwei Luo, Bo Dang, Junjian Zhang, Xiangyuan Cai, Hongwei Hu, Jingdong Chen, Yansheng Li",
      "workshop": ""
    },
    {
      "number": "G16",
      "title": "CASL: Curvature-Augmented Self-supervised Learning for 3D Anomaly Detection",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "清华大学深圳国际研究生院",
      "author": "Yaohua Cha, Yuerong Xue, Chunlin Fan, Yuansong Wang, Tao Dai, Ke Chen, Shutao Xia",
      "workshop": ""
    },
    {
      "number": "G17",
      "title": "OrienPose: Orientation-Guided Novel View Synthesis for Single-Image Unseen Object Pose Estimation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "西北工业大学",
      "author": "Yating Liu, Zhaoshuai Qi, Yang Zou, Yongnan Yang, Shizhou Zhang, Yanning Zhang",
      "workshop": ""
    },
    {
      "number": "G19",
      "title": "Faster and better 3d splatting via group training",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "湖南大学",
      "author": "Chengbo Wang, Guozheng Ma, Yifei Xue, Yizhen Lao",
      "workshop": ""
    },
    {
      "number": "G20",
      "title": "Layer Consistency Matters: Elegant Latent Transition Discrepancy for Generalizable Synthetic Image Detection",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "合肥工业大学",
      "author": "Yawen Yang, Feng Li, Shuqi Kong, Yunfeng Diao, Xinjian Gao, Zenglin Shi, Meng Wang",
      "workshop": ""
    },
    {
      "number": "G21",
      "title": "BeyondSparse: Facilitating Mamba to Enhance Cross-Domain 3D Semantic Segmentation in Adverse Weather",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "福州大学",
      "author": "Yao Wu, Mingwei Xing, Yachao Zhang, Fangyong Wang, Xiaopei Zhang, Yanyun Qu",
      "workshop": ""
    },
    {
      "number": "G22",
      "title": "PiercingEye: Dual-Space Video Violence Detection With Hyperbolic Vision-Language Guidance",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2025",
      "unit": "重庆邮电大学",
      "author": "Jiaxu Leng, Zhanjie Wu, Mingpi Tan, Mengjingcheng Mo, Jiankang Zheng, Qingqing Li, Ji Gan, Xinbo Gao",
      "workshop": ""
    },
    {
      "number": "G23",
      "title": "Online3R: Online Learning for Consistent Sequential Reconstruction Based on Geometry Foundation Model",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "北京大学",
      "author": "Shunkai Zhou, Zike Yan, Fei Xue, Dong Wu, Yuchen Deng, Hongbin Cha",
      "workshop": ""
    },
    {
      "number": "G24",
      "title": "Deep Hierarchical Learning for 3D Semantic Segmentation",
      "qikan": "International Journal of Computer Vision (IJCV) 2025",
      "unit": "西南交通大学",
      "author": "Chongshou Li,  Yuheng Liu,  Xinke Li,  Yuning Zhang,  Tianrui Li, Junsong Yuan",
      "workshop": ""
    },
    {
      "number": "G25",
      "title": "Domain-aware Category-level Geometry Learning Segmentation for 3D Point Clouds",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "西安电子科技大学",
      "author": "Pei He, Lingling Li, Licheng Jiao, Ronghua Shang, Fang Liu, Shuang Wang, Xu Liu, Wenping Ma",
      "workshop": ""
    },
    {
      "number": "G26",
      "title": "3D Visual Illusion Depth Estimation",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "北京理工大学",
      "author": "Chengtang Yao, Zhidan Liu, Jiaxi Ceng, Lidong Yu, Yuwei Wu, Yunde Jia",
      "workshop": ""
    },
    {
      "number": "G27",
      "title": "FusionPhys: A Flexible Framework for Fusing Complementary Sensing Modality in Remote Physiological Measurement",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "浙江大学",
      "author": "Chenhang Ying, Huiyu Yang, Jieyi Ge, Zhaodong Sun, Xu Cheng, Kui Ren, Xiaobai Li",
      "workshop": ""
    },
    {
      "number": "G28",
      "title": "Semantic Alignment and Reinforcement for Data-Free Quantization of Vision Transformers",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "厦门大学",
      "author": "Yunshan Zhong, Yuyao Zhou, Yuxin Zhang, Wanchen Sui, Shen Li, Yong Li, Fei Chao, Rongrong Ji",
      "workshop": ""
    },
    {
      "number": "G29",
      "title": "PreFM: Online Audio-Visual Event Parsing via Predictive Future Modeling",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "北京交通大学",
      "author": "Xiao Yu, Yan Fang, Xiaojie Jin, Yao Zhao, Yunchao Wei",
      "workshop": ""
    },
    {
      "number": "G30",
      "title": "Progressive Multi-cue Alignment for Unaligned RGBT Tracking",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "安徽大学",
      "author": "Jiandong Jin, Chenglong Li, Hao Feng, Andong Lu, Lili Huang, Jin Tang",
      "workshop": ""
    },
    {
      "number": "G31",
      "title": "Rethinking Multi-Modal Object Detection from the Perspective of  Mono-Modality Feature Learning",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "北京航空航天大学",
      "author": "Tianyi Zhao, Boyang Liu, Yanglei Gao, Yiming Sun, Maoxun Yuan, Xingxing Wei",
      "workshop": ""
    },
    {
      "number": "G32",
      "title": "Imagine Before Concentration: Diffusion-Guided Registers Enhance Partially Relevant Video Retrieval",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "哈尔滨工业大学(深圳)",
      "author": "Jun Li, Xuhang Lou, Jinpeng Wang, Yuting Wang, Yaowei Wang, Shutao Xia, Bin Chen",
      "workshop": ""
    },
    {
      "number": "G33",
      "title": "UniGeoSeg: Towards Unified Open-World Segmentation for Geospatial Scenes",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "北京理工大学；北京中关村学院",
      "author": "Shuo Ni, Di Wang, He Chen, Haonan Guo, Ning Zhang, Jing Zhang",
      "workshop": ""
    },
    {
      "number": "G34",
      "title": "EventGait: Towards Robust Gait Recognition with Event Streams",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中国科学技术大学",
      "author": "Senyan Xu, Shuai Chen, Chuanfu Shen, Kean Liu, Zhijing Sun, Chengzhi Cao, Xueyang Fu",
      "workshop": ""
    },
    {
      "number": "G35",
      "title": "Condensed Test-Time Adaptation of VLMs for Action Recognition",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京理工大学",
      "author": "Wenxuan Ge, Hongyu Qu, Rui Yan, Guosen Xie, Yazhou Yao, Xiangbo Shu, Jinhui Tang",
      "workshop": ""
    },
    {
      "number": "G36",
      "title": "EnvSocial-Diff: A Diffusion-Based Crowd Simulation Model with Environmental Conditioning and Individual-Group Interaction",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "深圳大学计算机与软件学院可视计算研究中心",
      "author": "Bingxue Zhao, Qi Zhang, Hui Huang",
      "workshop": ""
    },
    {
      "number": "G37",
      "title": "SynMVCrowd: A Large Synthetic Benchmark for Multi-view Crowd Counting and Localization",
      "qikan": "International Journal of Computer Vision (IJCV) 2026",
      "unit": "深圳大学计算机与软件学院",
      "author": "Qi Zhang, Daijie Chen, Yunfei Gong, Hui Huang",
      "workshop": ""
    },
    {
      "number": "G38",
      "title": "Where Does It Exist from the Low-Altitude:  Spatial Aerial Video Grounding",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "西北工业大学",
      "author": "Yang Zhan, Yuan Yuan",
      "workshop": ""
    },
    {
      "number": "G40",
      "title": "TopoPoint: Enhance Topology Reasoning via Endpoint Detection in Autonomous Driving",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2026",
      "unit": "中国科学院计算技术研究所",
      "author": "Yanping Fu, Xinyuan Liu, Tianyu Li, Yike Ma, Yucheng Zhang, Feng Dai",
      "workshop": ""
    },
    {
      "number": "G41",
      "title": "PE3R: Perception-Efficient 3D Reconstruction",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "新加坡国立大学",
      "author": "Jie Hu, Shizun Wang, Xinchao Wang",
      "workshop": ""
    },
    {
      "number": "G42",
      "title": "Temporal Rate Reduction Clustering for Human Motion Segmentation",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "北京邮电大学",
      "author": "Xianghan Meng, Zhengyu Tong, Zhiyuan Huang, Chunguang Li",
      "workshop": ""
    },
    {
      "number": "G43",
      "title": "From Pixels to Logic: A Perception-Reasoning Decomposition Framework for Open-World Referring Expression Comprehension",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "深圳大学计算机与软件学院",
      "author": "Lihong Huang, Shenghua Zhong, Zhi Zhang, Yan Liu",
      "workshop": ""
    },
    {
      "number": "G44",
      "title": "IMoRe: Implicit Program-Guided Reasoning for Human Motion Q&A",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "Agency for Science， Technology and Research (A*STAR)",
      "author": "Chen Li, Chinthani Sugandhika, Yeo Keat Ee, Eric Peh, Hao Zhang, Hong Yang, Deepu Rajan, Basura Fernando",
      "workshop": ""
    },
    {
      "number": "G45",
      "title": "Towards Generalizable AI-Generated Image Detection via Image-Adaptive Prompt Learning",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中国科学院自动化研究所",
      "author": "Yiheng Li, Zichang Tan, Guoqing Xu, Zhen Lei, Xu Zhou, Yang Yang",
      "workshop": ""
    },
    {
      "number": "G46",
      "title": "Seeing Motion Through Polarity for Event-based Action Recognition",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京理工大学",
      "author": "Meiqi Cao, Jiachao Zhang, Xin Jiang, Rui Yan, Yazhou Yao, Zechao Li, Xiangbo Shu",
      "workshop": ""
    },
    {
      "number": "G47",
      "title": "Test-Time Multi-Prompt Adaptation for Open-Vocabulary Remote Sensing Image Segmentation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "天津大学",
      "author": "Ting Yang, Qilong Wang, Qibin Hou, Qinghua Hu",
      "workshop": ""
    },
    {
      "number": "G48",
      "title": "Bézier Degradation Modeling for LiDAR-based Human Motion Capture",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京理工大学",
      "author": "Xiaoqi An, Lin Zhao, Jun Li, Chen Gong, Jian Yang",
      "workshop": ""
    },
    {
      "number": "G49",
      "title": "Learning Topology-Driven Multi-Subspace Fusion for Grassmannian Deep Networks",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "江南大学",
      "author": "Xuan Yu, Tianyang Xu",
      "workshop": ""
    },
    {
      "number": "G50",
      "title": "Language-Guided Graph Representation Learning for Video Summarization",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2025",
      "unit": "哈尔滨工业大学",
      "author": "Wenrui Li, Wei Han, Hengyu Man, Wangmeng Zuo, Xiaopeng Fan, Yonghong Tian",
      "workshop": ""
    },
    {
      "number": "G51",
      "title": "RS-SSM: Refining Forgotten Specifics in State Space Model for Video Semantic Segmentation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "北京大学王选计算机研究所",
      "author": "Kai Zhu, Zhenyu Cui, Zehua Zang, Jiahuan Zhou",
      "workshop": ""
    },
    {
      "number": "G52",
      "title": "Long short-term knowledge decomposition and consolidation for lifelong person re-identification",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2025",
      "unit": "北京大学",
      "author": "Kunlun Xu, Zichen Liu, Xu Zou, Yuxin Peng, Jiahuan Zhou",
      "workshop": ""
    },
    {
      "number": "G53",
      "title": "Towards Anytime Retrieval: A Benchmark for Anytime Person Re-Identification",
      "qikan": "International Joint Conference on Artificial Intelligence (IJCAI) 2025",
      "unit": "中国科学技术大学",
      "author": "Xulin Li, Yan Lu, Bin Liu, Jiaze Li, Qinhong Yang, Tao Gong, Qi Chu, Mang Ye, Nenghai Yu",
      "workshop": ""
    },
    {
      "number": "G54",
      "title": "VGGT-Long: Chunk it， Loop it， Align it， Pushing VGGT’s Limits on Kilometer-scale Long RGB Sequences",
      "qikan": "IEEE International Conference on Robotics and Automation (ICRA) 2026",
      "unit": "南开大学",
      "author": "Kai Deng, Zexin Ti, Jiawei Xu, Jian Yang, Jin Xie",
      "workshop": ""
    },
    {
      "number": "G55",
      "title": "History-Enhanced Two-Stage Transformer for Aerial Vision-and-Language Navigation",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "南京航空航天大学",
      "author": "Xichen Ding, Jianzhe Gao, Cong Pan, Wenguan Wang, Jie Qin",
      "workshop": ""
    },
    {
      "number": "G56",
      "title": "ArtHOI: Taming Foundation Models for Monocular 4D Reconstruction of Hand-Articulated-Object Interactions",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "哈尔滨工业大学",
      "author": "Zikai Wang, Zhilu Zhang, Yiqing Wang, Hui Li, Wangmeng Zuo",
      "workshop": ""
    },
    {
      "number": "G57",
      "title": "PointTPA: Dynamic Network Parameter Adaptation for 3D Scene Understanding",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "华中科技大学",
      "author": "Siyuan Liu, Chaoqun Zheng, Xin Zhou, Tianrui Feng, Dingkang Liang, Xiang Bai",
      "workshop": ""
    },
    {
      "number": "G58",
      "title": "Beyond Strict Pairing:Arbitrarily Paired Training for High-Performance Infrared and VisibleI mage Fusion",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "江南大学",
      "author": "Yanglin Deng, Tianyang Xu, Chunyang Cheng, Xiaojun Wu, Josef Kittler",
      "workshop": ""
    },
    {
      "number": "G59",
      "title": "Dit4sr: Taming diffusion transformer for real-world image super-resolution",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "南开大学",
      "author": "Zheng-Peng Duan, Jiawei Zhang, Xin Jin, Ziheng Zhang, Zheng Xiong, Dongqing Zou, Jimmy S. Ren, Chun-Le Guo, Chongyi Li",
      "workshop": ""
    },
    {
      "number": "G60",
      "title": "3D Hand Pose Estimation via Articulated Anchor-to-Joint 3D Local Regressors",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "华中科技大学",
      "author": "Changlong Jiang, Yang Xiao, Jinghong Zheng, Haohong Kuang, Cunlin Wu, Mingyang Zhang, Zhiguo Cao, Min Du, Tianyi Zhou, Junsong Yuan",
      "workshop": ""
    },
    {
      "number": "G61",
      "title": "Boosting Self-Supervised Tracking with Contextual Prompts and Noise Learning",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "广西师范大学",
      "author": "Yaozong Zheng, Qihua Liang, Bineng Zhong, Shuimu Ceng, Yuanliang Xue, Ning Li, Shuxiang Song",
      "workshop": ""
    },
    {
      "number": "G62",
      "title": "Generalizable Non-Line-of-Sight Imaging with Learnable Physical Priors",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "中国科学技术大学",
      "author": "Shida Sun, Yue Li, Yueyi Zhang, Zhiwei Xiong",
      "workshop": ""
    },
    {
      "number": "G63",
      "title": "Let synthetic data shine: Domain reassembly and soft-fusion for single domain generalization",
      "qikan": "International Journal of Computer Vision (IJCV) 2026",
      "unit": "国防科技大学",
      "author": "Hao Li, Yubin Xiao, Ke Liang, Mengzhu Wang, Long Lan, Kenli Li, Xinwang Liu",
      "workshop": ""
    },
    {
      "number": "H01",
      "title": "DOTA: DistributiOnal Test-time Adaptation of Vision-Language Models",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "天津大学",
      "author": "Zongbo Han, Jialong Yang, Guangyu Wang, Junfan Li, Qianli Xu, Mike Zheng Shou, Changqing Zhang",
      "workshop": ""
    },
    {
      "number": "H02",
      "title": "Curvature Learning for the Generalization of Hyperbolic Neural Networks",
      "qikan": "International Journal of Computer Vision (IJCV) 2025",
      "unit": "北京理工大学",
      "author": "Xiaomeng Fan, Yuwei Wu, Zhi Gao, Mehrtash Harandi, Yunde Jia",
      "workshop": ""
    },
    {
      "number": "H03",
      "title": "Exploring the Vulnerabilities of Federated Learning: A Deep Dive Into Gradient Inversion Attacks",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "香港大学",
      "author": "Pengxin Guo, Runxi Wang, Shuang Zeng, Jinjing Zhu, Haoning Jiang, Yanran Wang, Yuyin Zhou, Feifei Wang, Hui Xiong, Liangqiong Qu",
      "workshop": ""
    },
    {
      "number": "H04",
      "title": "Gpg: A simple and strong reinforcement learning baseline for model reasoning",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "阿里巴巴集团-高德地图",
      "author": "Xiangxiang Chu, Hailang Huang, Xiao Zhang, Fei Wei, Yong Wang",
      "workshop": ""
    },
    {
      "number": "H05",
      "title": "A Hidden Stumbling Block in Generalized Category Discovery: Distracted Attention",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "云南师范大学",
      "author": "Qiyu Xu, Zhanxuan Hu, Yu Duan, Ercheng Pei, Yonghang Tai",
      "workshop": ""
    },
    {
      "number": "H06",
      "title": "Vision-Language Models Guided Graph Concept Reasoning for Interpretable Diabetic Retinopathy Diagnosis",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "深圳大学",
      "author": "Qihao Xu, Xiaoling Luo, Yuxin Lin, Chengliang Liu, Yongting Hu, Jinkai Li, Xinheng Lv, Yong Xu",
      "workshop": ""
    },
    {
      "number": "H07",
      "title": "Progress-Think: Semantic Progress Reasoning for Vision-Language Navigation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中国人民大学",
      "author": "Shuo Wang, Yucheng Wang, Guoxin Lian, Yongcai Wang, Maiyue Chen, Kaihui Wang, Bo Zhang, Zhizhong Su, Yutian Zhou, Wanting Li, Deying Li, Zhaoxin Fan",
      "workshop": ""
    },
    {
      "number": "H08",
      "title": "WildVideo: Benchmarking LMMs for Understanding Video-Language Interaction",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2025",
      "unit": "国防科技大学，中山大学",
      "author": "Songyuan Yang, Weijiang Yu, Wenjing Yang, Xinwang Liu, Huibin Tan, Long Lan, Nong Xiao",
      "workshop": ""
    },
    {
      "number": "H09",
      "title": "MoMa-Kitchen: A 100K+ Benchmark for Affordance-Grounded Last-Mile Navigation in Mobile Manipulation",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "复旦大学&上海人工智能实验室",
      "author": "Pingrui Zhang, Xianqiang Gao, Yuhan Wu, Kehui Liu, Dong Wang, Zhigang Wang, Bin Zhao, Yan Ding, Xuelong Li",
      "workshop": ""
    },
    {
      "number": "H10",
      "title": "Plant Taxonomy Meets Plant Counting: A Fine-Grained， Taxonomic Dataset for Counting Hundreds of Plant Species",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "华中科技大学",
      "author": "Jinyu Xu, Tianqi Hu, Xiaonan Hu, Letian Zhou, Songliang Cao, Meng Zhang, Hao Lu",
      "workshop": ""
    },
    {
      "number": "H11",
      "title": "LabUtopia: High-Fidelity Simulation and Hierarchical Benchmark for Scientific Embodied Agents",
      "qikan": "Conference on Neural Information Processing Systems (NeurIPS) 2025",
      "unit": "上海人工智能实验室",
      "author": "Rui Li, Zixuan Hu, Wenxi Qu, Jinouwen Zhang, Zhenfei Yin, Sha Zhang, Xuantuo Huang, Hanqing Wang, Tai Wang, Jiangmiao Pang, Wanli Ouyang, Lei Bai, Wangmeng Zuo, Lingyu Duan, Dongzhan Zhou, Shixiang Tang",
      "workshop": ""
    },
    {
      "number": "H12",
      "title": "UnrealZoo: Enriching Photo-realistic Virtual Worlds for Embodied AI",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "北京师范大学",
      "author": "Fangwei Zhong, Kui Wu, Churan Wang, Hao Chen, Hai Zi, Zhoujun Li, Yizhou Wang",
      "workshop": ""
    },
    {
      "number": "H13",
      "title": "Revisiting Cross-Architecture Distillation: Adaptive Dual-Teacher Transfer for Lightweight Video Models",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "华南理工大学",
      "author": "Ying Peng, Hongsen Ye, Changxin Huang, Xiping Hu, Jian Chen, Runhao Ceng",
      "workshop": ""
    },
    {
      "number": "H14",
      "title": "Generalization-Preserved Learning: Closing the Backdoor to Catastrophic Forgetting in Continual Deepfake Detection",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "深圳河套学院",
      "author": "Xueyi Zhang, Peiyin Zhu, Chengwei Zhang, Zhiyuan Yan, Jikang Cheng, Mingrui Lao, Siqi Cai, Yanming Guo",
      "workshop": ""
    },
    {
      "number": "H15",
      "title": "Radar-APLANC: Unsupervised Radar-based Heartbeat Sensing via Augmented Pseudo-Label and Noise Contrast",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "南京信息工程大学",
      "author": "Ying Wang, Zhaodong Sun, Xu Cheng, Zuxian He, Xiaobai Li",
      "workshop": ""
    },
    {
      "number": "H16",
      "title": "ChinaTravel: An Open-Ended Travel Planning Benchmark with Compositional Constraint Validation for Language Agents",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "南京大学",
      "author": "Jiejing Shao, Bowen Zhang, Xiaowen Yang, Baizhi Chen, Siyu Han, Jinghao Pang, Wenda Wei, Guohao Cai, Zhenhua Dong, Lanzhe Guo, Yufeng Li",
      "workshop": ""
    },
    {
      "number": "H17",
      "title": "DriveVLA-W0: World Models Amplify Data Scaling Law in Autonomous Driving",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "中国科学院自动化研究所",
      "author": "Yingyan Li, Shuyao Shang, Weisong Liu, Bing Zhan, Haochen Wang, Yuqi Wang, Yuntao Chen, Xiaoman Wang, Yasong An, Chufeng Tang, Lu Hou, Lve Fan, Zhaoxiang Zhang",
      "workshop": ""
    },
    {
      "number": "H18",
      "title": "STRNet: Visual Navigation with Spatio-Temporal Representation through Dynamic Graph Aggregation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中山大学",
      "author": "Hao Ren, Zetong Bi, Yiming Zeng, Zhaoliang Wan, Lu Qi, Hui Cheng",
      "workshop": ""
    },
    {
      "number": "H19",
      "title": "Human-like Cognitive Generalization for Large Models via Mental Representation-Guided Supervision",
      "qikan": "Nature Communications 2026",
      "unit": "浙江大学",
      "author": "Jiaxuan Chen, Yu Qi, Yueming Wang, Gang Pan",
      "workshop": ""
    },
    {
      "number": "H20",
      "title": "MFI-ResNet: Efficient ResNet Architecture Optimization via MeanFlow Compression and Selective Incubation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "网络空间部队信息工程大学",
      "author": "Nuolin Sun, Linyuan Wang, Haonan Wei, Lei Li, Bin Yan",
      "workshop": ""
    },
    {
      "number": "H22",
      "title": "Shedding Light on VLN Robustness: A Black-box Framework for Indoor Lighting-based Adversarial Attack",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南洋理工大学",
      "author": "Chenyang Li, Wenbing Tang, Yihao Huang, Sinong Zhan, Ming Hu, Xiaojun Jia, Yang Liu",
      "workshop": ""
    },
    {
      "number": "H23",
      "title": "FeatureBench: Benchmarking Agentic Coding for Complex Feature Development",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "中国科学院自动化所",
      "author": "Qixing Zhou, Jiacheng Zhang, Haiyang Wang, Rui Hao, Jiahe Wang, Minghao Han, Yuxue Yang, Shuzhe Wu, Feiyang Pan, Lve Fan, Dandan Tu, Zhaoxiang Zhang",
      "workshop": ""
    },
    {
      "number": "H24",
      "title": "HoliTracer: Holistic Vectorization of Geographic Objects from Large-Size Remote Sensing Imagery",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "武汉大学",
      "author": "Yu Wang, Bo Dang, Wanchun Li, Wei Chen, Yansheng Li",
      "workshop": ""
    },
    {
      "number": "H25",
      "title": "A Mixed-Curvature based Pre-training Paradigm for Multi-Task Vehicle Routing Solver",
      "qikan": "International Conference on Machine Learning (ICML) 2025",
      "unit": "中山大学 深圳校区",
      "author": "Suyu Liu, Zhiguang Cao, Shanshan Feng, Ong-Yew Soon",
      "workshop": ""
    },
    {
      "number": "H26",
      "title": "IVEBench: Modern Benchmark Suite for Instruction-Guided Video Editing Assessment",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "浙江大学",
      "author": "Yinan Chen, Jiangning Zhang, Teng Hu, Yuxiang Ceng, Zhucun Xue, Qingdong He, Chengjie Wang, Yong Liu, Xiaobin Hu, Shuicheng Yan",
      "workshop": ""
    },
    {
      "number": "H27",
      "title": "Music Grounding by Short Video",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "中国人民大学",
      "author": "Zijie Xin, Minquan Wang, Jingyu Liu, Ye Ma, Quan Chen, Peng Jiang, Xirong Li",
      "workshop": ""
    },
    {
      "number": "H28",
      "title": "DC-Merge: Improving Model Merging with Directional Consistency",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "东南大学计算机科学与工程学院",
      "author": "Hanchen Zhang, Zihao Zhou, Maolin Luo, Shimin Di, Minling Zhang, Tong Wei",
      "workshop": ""
    },
    {
      "number": "H29",
      "title": "History to Future: Evolving Agent with Experience and Thought for Zero-shot Vision-and-Language Navigation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "南京理工大学",
      "author": "Guangzhao Dai, Shuo Wang, Zihan Wang, Guosen Xie, Yang Yang, Jinshan Pan, Qianru Sun, Xiangbo Shu",
      "workshop": ""
    },
    {
      "number": "H30",
      "title": "Garments2Look: A Multi-Reference Dataset for High-Fidelity Outfit-Level Virtual Try-On with Clothing and Accessories",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "香港理工大学",
      "author": "Junyao Hu, Zhongwei Cheng, Weiqiang Huang, Xingxing Zou",
      "workshop": ""
    },
    {
      "number": "H31",
      "title": "M3CoTBench: Benchmark Chain-of-Thought of MLLMs in Medical Image Understanding",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "浙江大学",
      "author": "Juntao Jiang, Jiangning Zhang, Yali Bi, Jinsheng Bai, Weixuan Liu, Weiwei Jin, Zhucun Xue, Yong Liu, Xiaobin Hu, Shuicheng Yan",
      "workshop": ""
    },
    {
      "number": "H32",
      "title": "AR-VRM: Imitating Human Motions for Visual Robot Manipulation with Analogical Reasoning",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "北京大学",
      "author": "Dejie Yang, Zijing Zhao, Yang Liu",
      "workshop": ""
    },
    {
      "number": "H33",
      "title": "Do Vision-Language Models Measure Up? Benchmarking Visual Measurement Reading with MeasureBench",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "武汉大学",
      "author": "Fenfen Lin, Yesheng Liu, Haiyu Xu, Yue Chen, Zheqi He, Mingxuan Zhao, Miguel Hu Chen, Jinge Yao, Xi Yang",
      "workshop": ""
    },
    {
      "number": "H34",
      "title": "Batman: Benign Knowledge Alignment Through Malicious Null Space in Federated Backdoor Attack",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "武汉大学",
      "author": "Wenwen He, Wenke Huang, Yiyang Fang, Wenjie Qu, Jiaheng Zhang, Mang Ye",
      "workshop": ""
    },
    {
      "number": "H37",
      "title": "Adaptive Momentum and EMA-weighted Modeling for Imbalanced Label Distribution Learning",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "齐鲁工业大学",
      "author": "Yongbiao Gao, Xiangcheng Sun, Chao Tan, Chunyu Hu, Guohua Lv",
      "workshop": ""
    },
    {
      "number": "H39",
      "title": "Dynamic Attention Analysis for Backdoor Detection in Text-to-Image Diffusion Models",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "中科院计算技术研究所",
      "author": "Zhongqi Wang, Jie Zhang, Shiguang Shan, Xilin Chen",
      "workshop": ""
    },
    {
      "number": "H40",
      "title": "Fine-grained Image Aesthetic Assessment: Learning Discriminative Scores from Relative Ranks",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "西安电子科技大学",
      "author": "Zhichao Yang, Jianjie Wang, Zhixianhe Zhang, Pangu Xie, Xiangfei Sheng, Pengfei Chen, Leida Li",
      "workshop": ""
    },
    {
      "number": "H41",
      "title": "CKDA: Cross-modality Knowledge Disentanglement and Alignment for Visible-Infrared Lifelong Person Re-identification",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "清华大学",
      "author": "Zhenyu Cui, Jiahuan Zhou, Yuxin Peng",
      "workshop": ""
    },
    {
      "number": "H42",
      "title": "Adversarial Data Augmentation for Single Domain Generalization via Lyapunov Exponent-Guided Optimization",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "重庆邮电大学",
      "author": "Zuyu Zhang, Ning Chen, Yongshan Liu, Qinghua Zhang, Xu Zhang",
      "workshop": ""
    },
    {
      "number": "H43",
      "title": "AdaCuRL: Adaptive Curriculum Reinforcement Learning with Invalid Sample Mitigation and Historical Revisiting",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "AMAP, Alibaba Group",
      "author": "Renda Li, Hailang Huang, Fei Wei, Feng Xiong, Yong Wang, Xiangxiang Chu",
      "workshop": ""
    },
    {
      "number": "H44",
      "title": "VasoMIM: Vascular Anatomy-Aware Masked Image Modeling for Vessel Segmentation",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "中国科学院自动化研究所",
      "author": "Dexing Huang, Xiaohu Zhou, Meijiang Gui, Xiaoliang Xie, Shiqi Liu, Shuangyi Wang, Tianyu Xiang, Ruize Ma, Nufang Xiao, Zengguang Hou",
      "workshop": ""
    },
    {
      "number": "H45",
      "title": "SynerDetect: Hierarchical Synergistic Learning for Generalizable AI-Generated Image Detection",
      "qikan": "AAAI Conference on Artificial Intelligence (AAAI) 2026",
      "unit": "香港科技大学（广州）",
      "author": "Shuaibo Li, Yijun Yang, Zhaohu Xing, Hongqiu Wang, Pengfei Hao, Xingyu Li, Zekai Liu, Qing Zhang, Lei Zhu",
      "workshop": ""
    },
    {
      "number": "H46",
      "title": "Long-RVOS: A Comprehensive Benchmark for Long-term Referring Video Object Segmentation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "中山大学",
      "author": "Tianming Liang, Haichao Jiang, Yuting Yang, Chaolei Tan, Shuai Li, Weishi Zheng, Jianfang Hu",
      "workshop": ""
    },
    {
      "number": "H47",
      "title": "BiKT: Unleashing the Potential of GNNs via Bi-Directional Knowledge Transfer",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "北京交通大学",
      "author": "Shuai Zheng, Zhizhe Liu, Zhenfeng Zhu, Xingxing Zhang, Jianxin Li, Yao Zhao",
      "workshop": ""
    },
    {
      "number": "H48",
      "title": "EvaNet: Towards More Efficient and Consistent Infrared and Visible Image Fusion Assessment",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "江南大学",
      "author": "Chunyang Cheng, Tianyang Xu, Xiaojun Wu, Tao Zhou, Hui Li, Zhangyong Tang, Josef Kittler",
      "workshop": ""
    },
    {
      "number": "H49",
      "title": "NESTOR: A Nested MOE-based Neural Operator for Large-Scale PDE Pre-Training",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "安徽大学",
      "author": "Dengdi Sun, Xiaoya Zhou, Xiao Wang, Hao Si, Wanli Lyu, Jin Tang, Bin Luo",
      "workshop": ""
    },
    {
      "number": "H50",
      "title": "Φ-GAN: Physics-Inspired GAN for Generating SAR Images Under Limited Data",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "西北工业大学",
      "author": "Xidan Zhang, Yihan Zhuang, Qian Guo, Haodong Yang, Xuelin Qian, Gong Cheng, Junwei Han, Zhongling Huang",
      "workshop": ""
    },
    {
      "number": "H51",
      "title": "Sparsely Timing the Change: A Spiking Temporal Framework for Remote Sensing Interpretation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "电子科技大学",
      "author": "Shilong Li, Xiurui Xie, Qiugang Zhan, Luochao Wang, Yong Deng, Guisong Liu",
      "workshop": ""
    },
    {
      "number": "H52",
      "title": "MACHANet: Memory-Augmented Cross Modal\nHybrid Alignment Network for Unsupervised\nVisible-Infrared Person Re-Identification",
      "qikan": "IEEE Transactions on Information Forensics and Security (TIFS) 2026",
      "unit": "烟台大学",
      "author": "Tingyu Yang, Weiqing Yan, Guanghui Yue, Wujie Zhou, Chang Tang",
      "workshop": ""
    },
    {
      "number": "H53",
      "title": "An interpretable deep learning model for first-trimester fetal cardiac screening",
      "qikan": "npj Digital Medicine 2025",
      "unit": "武汉大学",
      "author": "Wenjia Lei, Chi Wen, He Li, Shuihua Yang, Kuifang Chen, Hongxia Yuan, Hezhou Li, Hong Xu, Xinru Gao, Simin Zhang, Zuojian Yang, Mang Ye, Bo Du, Qingqing Wu",
      "workshop": ""
    },
    {
      "number": "H54",
      "title": "ReMP-AD: Retrieval-enhanced Multi-modal Prompt Fusion for Few-Shot Industrial Visual Anomaly Detection",
      "qikan": "IEEE/CVF International Conference on Computer Vision (ICCV) 2025",
      "unit": "哈尔滨工业大学",
      "author": "Hongchi Ma, Guanglei Yang, Debin Zhao, Yanli Ji, Wangmeng Zuo",
      "workshop": ""
    },
    {
      "number": "H55",
      "title": "RiskProp: Collision-Anchored Self-Supervised Risk Propagation for Early Accident Anticipation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "武汉大学",
      "author": "Yiyang Zou, Tianhao Zhao, Peilun Xiao, Hongyu Jin, Longyu Qi, Yuxuan Li, Liyin Liang, Yifeng Qian, Chunbo Lai, Yutian Lin, Zhihui Li, Yu Wu",
      "workshop": ""
    },
    {
      "number": "H56",
      "title": "Diversity over Uniformity: Rethinking Representation in Generated Image Detection",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "重庆邮电大学",
      "author": "Qinghui He, Haifeng Zhang, Qiao Qin, Bo Liu, Xiuli Bi, Bin Xiao",
      "workshop": ""
    },
    {
      "number": "H57",
      "title": "Fixed Anchors Are Not Enough: Dynamic Retrieval and Persistent Homology for Dataset Distillation",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "电子科技大学",
      "author": "Muquan Li, Hang Gou, Yingyi Ma, Rongzheng Wang, Ke Qin, Tao He",
      "workshop": ""
    },
    {
      "number": "H58",
      "title": "Towards Stable Federated Continual Test-Time Adaptation in Wild World",
      "qikan": "IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) 2026",
      "unit": "安徽大学",
      "author": "Liwen Wang, Xingbo Dong, Iman Yi Liao, Zhe Jin",
      "workshop": ""
    },
    {
      "number": "H59",
      "title": "Doloris: Dual Conditional Diffusion Implicit Bridges with Sparsity Masking Strategy for Unpaired Single-Cell Perturbation Estimation",
      "qikan": "International Conference on Learning Representations (ICLR) 2026",
      "unit": "浙江大学",
      "author": "Changxi Chi, Jun Xia, Yufei Huang, Zhuoli Ouyang, Cheng Tan, Yunfan Liu, Jingbo Zhou, Chang Yu, Liangyu Yuan, Siyuan Li, Zelin Zang, Stan Z. Li",
      "workshop": ""
    },
    
    {
      "number": "H61",
      "title": "SkyFind: A Large-Scale Benchmark Unveiling Referring Expression Comprehension for UAV",
      "qikan": "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI) 2026",
      "unit": "中国科学技术大学",
      "author": "Kunyu Wang, Guanbo Wu, Xueyang Fu, Xingbo Wang, Kean Liu, Xin Lu, Chengjie Ge, Wei Di, Zhengjun Cha",
      "workshop": ""
    },
    {
      "number": "H62",
      "title": "SuperCL: Superpixel Guided Contrastive Learning for Medical Image Segmentation Pre-Training",
      "qikan": "IEEE Transactions on Image Processing (TIP) 2026",
      "unit": "北京大学未来技术学院生物医学工程系，美国佐治亚理工学院生物医学工程系",
      "author": "Shuang Zeng, Lei Zhu, Xinliang Zhang, Hangzhou He, Yanye Lu",
      "workshop": ""
    }
    
  ],
  highlight:[]
}



// WEBPACK FOOTER //
// ./src/router/posterandspotlight.js